<template>
    <div class="row">
        <div class="col-12 padding-t-b-0" v-show="showPlayDictation" style="text-align: center;position: fixed;top: 0;left: 0;z-index: 1;background-color: #FCFCFC;padding: 0;">
            <div class="d-flex bd-highlight">
                <div class="p-2 flex-grow-1 bd-highlight" style="text-align: right;">
                    <audio :src="dictationSrc" :type="audioType" id="dicAudio" ref="player" controls autoplay controlsList="nodownload" crossorigin="anonymous">
                        <p>Your browser doesn't support HTML5 audio. Here is a <a @click="downloadDictation" href="#">link to the audio</a> instead.</p>
                    </audio>
                </div>
                <div class="p-2 flex-grow-1 bd-highlight" style="padding-top: 25px !important; text-align: left;">
                    If dictation dosen't play <a @click="downloadDictation" href="#" style="text-decoration:none; font-weight: 600;">Click Here</a>
                    <button @click="hidePlayDictation" class="btn btn-sm btn-primary-outline" style="margin-left: 15px;"><span>Close</span></button>
                </div>
            </div>
        </div>
        <div class="col-12 padding-t-b-0">
            <div class="text-center">
                <loading :active.sync="loading" :is-full-page="fullPage" color="#016BAB"></loading>
                <v-dialog v-model="showLogin" width="600">
                    <v-card>
                        <v-card-title class="headline grey lighten-2"
                                      style="background-color: #016BAB !important;"
                                      primary-title>
                            Login
                        </v-card-title>
                        <v-card-text>
                            <div class="row search-dialog">
                                <div class="col-sm-12 text-left">
                                    <label v-show="showInvalidUser == true" class="text-danger">Invalid user authentication.</label>
                                </div>
                                <div class="col-sm-12">
                                    <v-text-field class="" v-model="userId" label="* Login Id" solo></v-text-field>
                                </div>
                                <div class="col-sm-12">
                                    <v-text-field :type="'password'" class="" v-model="userPassword" label="* Password" solo v-on:keyup.enter.native="userLogin"></v-text-field>
                                </div>
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary"
                                   text
                                   @click="userLogin" v-bind:disabled="! userId || !userPassword">
                                Login
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="showChangePassword" width="600">
                    <v-card>
                        <v-card-title class="headline grey lighten-2"
                                      style="background-color: #016BAB !important;"
                                      primary-title>
                            Change Password
                        </v-card-title>
                        <v-card-text>
                            <div class="row search-dialog">
                                <div class="col-sm-12">
                                </div>
                                <div class="col-sm-12">
                                    <v-text-field :type="'password'" class="" v-model="changeOldPassword" label="* Old Password" solo></v-text-field>
                                </div>
                                <div class="col-sm-12">
                                    <v-text-field ref="password" :type="'password'" class="" v-on:keyup="newPasswordChange" v-model="changeNewPassword" label="* New Password" solo></v-text-field>
                                </div>
                                <div class="col-sm-12">
                                    <v-text-field :type="'password'" class="" v-model="changeConfirmPassword" label="* Confirm Password" solo v-on:keyup.enter.native="changePassword"></v-text-field>
                                </div>
                                <div class="col-sm-12">
                                    <span v-show="changeNewPassword && changeConfirmPassword && changeNewPassword != changeConfirmPassword" class="text-danger">Invalid confirm password</span>
                                </div>
                                <div class="col-sm-12" v-show="invalidPasswordStrength">
                                    <div class="row invalidPasswordStrength">
                                        <div class="col-sm-12 font-weight-bold">Password Hint:</div>
                                        <div class="col-sm-12 letter">A <b>lowercase</b> letter</div>
                                        <div class="col-sm-12 capital">A <b>capital (uppercase)</b> letter</div>
                                        <div class="col-sm-12 number">A <b>number</b></div>
                                        <div class="col-sm-12 specialCharacters">A <b>special character</b></div>
                                        <div class="col-sm-12 length">Minimum <b>8 characters</b></div>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn v-bind:disabled="changeNewPassword != changeConfirmPassword || invalidPasswordStrength" color="primary"
                                   text
                                   @click="changePassword">
                                Change
                            </v-btn>
                            <v-btn color="primary"
                                   text
                                   @click="showChangePassword=false">
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="showAlert" width="600">
                    <v-card>
                        <v-card-title class="headline grey lighten-2"
                                      style="background-color: #016BAB !important;"
                                      primary-title>
                            Support Alert
                        </v-card-title>
                        <v-card-text>
                            <div class="row search-dialog">
                                <div class="col-sm-12 text-left">
                                    <label>Please use this alert only for urgent system related complaints. For any non-urgent enquiries please email on <a href="mailto:info@accesstek-ltd.com">info@accesstek-ltd.com</a></label>
                                </div>
                                <div class="col-sm-12">
                                    <v-select :items="supports"
                                              v-model="support"
                                              item-text="supportText"
                                              solo
                                              return-object
                                              label="Problem">
                                    </v-select>
                                </div>
                                <div class="col-sm-12">
                                    <textarea rows="8" class="form-control form-control-sm" v-model="alertText"></textarea>
                                </div>
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary"
                                   text
                                   @click="resetAlert" v-bind:disabled="!support || !alertText">
                                Reset
                            </v-btn>
                            <v-btn color="primary"
                                   text
                                   @click="sendAlert" v-bind:disabled="!support || !alertText">
                                Send
                            </v-btn>
                            <v-btn color="primary"
                                   text
                                   @click="showAlert = false">
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="searchDialog" width="800">
                    <v-card>
                        <v-card-title class="headline grey lighten-2"
                                      style="background-color: #016BAB !important;"
                                      primary-title>
                            Search
                        </v-card-title>

                        <v-card-text style="padding-bottom: 0px;">
                            <div class="row search-dialog">
                                <div class="col-sm-6">
                                    <multiselect v-model="selectedSearchAccounts" :options="accountsWithoutAllOption" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select Accounts" label="hosName" track-by="hosName" :preselect-first="true" :taggable="false">
                                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                                            <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span>
                                        </template>
                                    </multiselect>
                                    <!--<v-select :items="accounts"
                                              v-model="sFilterHospital"
                                              item-text="hosName"
                                              solo
                                              return-object
                                              label="All Accounts">
                                    </v-select>-->
                                </div>
                                <div class="col-sm-6">
                                    <multiselect :disabled="checkboxOWS" v-model="sFilterDictator"
                                                 deselect-label="Selected"
                                                 track-by="cliName" label="cliName"
                                                 placeholder="Select Dictator"
                                                 :options="sFilterdictators"
                                                 :searchable="false"
                                                 :allow-empty="false">
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            {{ option.cliName }}
                                        </template>
                                    </multiselect>
                                    <!--<v-select :items="sFilterdictators"
                                    v-model="sFilterDictator"
                                    item-text="cliName"
                                    solo
                                    return-object
                                    label="All Dictators"></v-select>-->
                                </div>
                                <div class="clearfix"></div>
                                <div class="col-sm-12">
                                    <v-text-field class="" v-model="keywords" label="Keywords" solo></v-text-field>
                                </div>
                                <div class="col-sm-6">
                                    <v-menu v-model="menuFromDate"
                                            :close-on-content-click="false"
                                            :nudge-right="0"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :value="fromDateFormat"
                                                          label="From"
                                                          readonly
                                                          v-on="on"
                                                          v-bind="attrs"
                                                          @click:clear="fromDate = null">

                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="fromDate" @input="menuFromDate = false"></v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="col-sm-6">
                                    <v-menu v-model="menuToDate"
                                            :close-on-content-click="false"
                                            :nudge-right="0"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :value="toDateFormat"
                                                          label="To"
                                                          readonly
                                                          v-on="on"
                                                          v-bind="attrs"
                                                          @click:clear="toDate = null">

                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="toDate" @input="menuToDate = false"></v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="clearfix"></div>
                                <div class="col-sm-12">
                                    <form class="form-inline search">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <v-checkbox v-model="patientName" label="Patient Name"></v-checkbox>
                                                    <v-checkbox v-model="patientNo" label="Patient No"></v-checkbox>
                                                    <v-checkbox v-model="nhsNo" label="NHS No"></v-checkbox>
                                                    <v-checkbox v-model="subject" label="Subject"></v-checkbox>
                                                    <v-checkbox v-model="documentContent" label="Document Content"></v-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="form-group" title="Organisation wide search">
                                                    <v-checkbox v-model="checkboxOWS" label="Organisation-wide search"></v-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <div class="row" style="margin: 0px;">
                                <div class="col-md-6" style="padding-left: 0;padding-top: 0;padding-bottom:0;text-align: left;">
                                    <v-btn color="primary"
                                           text
                                           v-bind:disabled="!selectedSearchAccounts || selectedSearchAccounts.length == 0"
                                           @click="searchAndExportReport">
                                        Export Search Result
                                    </v-btn>
                                </div>
                                <div class="col-md-6" style="padding-top: 0;padding-bottom:0;text-align: right;">
                                    <v-btn color="primary"
                                           text
                                           v-bind:disabled="!selectedSearchAccounts || selectedSearchAccounts.length == 0"
                                           @click="searchTransactions">
                                        Search
                                    </v-btn>
                                    <v-btn color="primary"
                                           text
                                           @click="searchDialog = !searchDialog">
                                        Cancel
                                    </v-btn>
                                </div>
                            </div>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="showUpload" width="85vw" style="height: 95vh;" scrollable persistent>
                    <v-card>
                        <v-card-text>
                            <v-container fluid>
                                <v-row>
                                    <v-col class="d-flex" cols="12" sm="6" style="background-color: rgb(217, 233, 248);">
                                        <div class="input-group">
                                            <div class="input-group-prepend" style="height: 33px;">
                                                <span class="input-group-text" style="background-color: transparent;border:none;">Account:</span>
                                            </div>
                                            <v-select :items="accountsWithoutAllOption"
                                                      v-model="recordingHospital"
                                                      item-text="hosName"
                                                      @change="recordingHospitalChange"
                                                      solo
                                                      return-object
                                                      label="Account">
                                            </v-select>
                                        </div>
                                    </v-col>
                                    <v-col class="d-flex" cols="12" sm="6" style="background-color: rgb(217, 233, 248);">
                                        <div class="input-group">
                                            <div class="input-group-prepend" style="height: 33px;">
                                                <span class="input-group-text" style="background-color: transparent;border:none;">Dictator:</span>
                                            </div>
                                            <v-select :items="dictatorsWithoutAllOption"
                                                      v-model="recordingDictator"
                                                      item-text="cliName"
                                                      solo
                                                      return-object
                                                      label="Dictator">
                                            </v-select>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12" style="padding:0;">
                                        <v-tabs background-color="indigo"
                                                dark
                                                @change="uploadTabChanged">
                                            <v-tab>
                                                Upload Dictations
                                            </v-tab>
                                            <v-tab v-if="isMobile == false">
                                                Record Dictations
                                            </v-tab>
                                            <v-tab-item>
                                                <v-card>
                                                    <v-card-text>
                                                        <div style="min-height: 442px;">
                                                            <div class="row">
                                                                <div class="cell col-sm-12" style="padding-bottom: 5px;">
                                                                    <label>Clinic Date:</label>&nbsp;<input type="text" class="form-control form-control-sm" v-model="clinicDate" placeholder="dd/mm/yyyy" />
                                                                </div>
                                                            </div>
                                                            <div class="large-12 medium-12 small-12 cell">
                                                                <input type="file" id="files" ref="files" accept="audio/*,.dss,.ds2" multiple v-on:change="handleFileUploads()" />
                                                            </div>
                                                            <div class="row dictation-grid" style="max-height: 350px; overflow-y:auto; overflow-x:hidden;margin: 0;">
                                                                <div class="col-md-12 text-center" v-show="uploading">
                                                                    <v-progress-linear v-model="uploading_progress"></v-progress-linear>
                                                                    <!--<v-progress-circular :size="42"
                                                                                         :width="5"
                                                                                         :rotate="90"
                                                                                         :value="uploading_progress"
                                                                                         color="green">
                                                                        {{ uploading_progress }}
                                                                    </v-progress-circular>-->
                                                                </div>
                                                                <div class="col-md-12 dictation" style="padding-top: 0px;padding-bottom: 0px;" v-for="(file, key) in files" v-bind:key="key">
                                                                    <div class="d-flex bd-highlight">
                                                                        <div class="p-2 bd-highlight">
                                                                            {{key + 1}}.
                                                                        </div>
                                                                        <div class="p-2 flex-grow-1 bd-highlight">{{ file.name }}</div>
                                                                        <div class="p-2 bd-highlight"><button @click="removeFile(key)" style="outline: none;border: none;"><i class="fa fa-times" aria-hidden="true" style="cursor: pointer;color: #dc3545;" title="Remove"></i></button></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12 text-right">
                                                                <v-btn color="primary"
                                                                       text
                                                                       @click="browseEvent">
                                                                    Browse
                                                                </v-btn>
                                                                <v-btn color="primary"
                                                                       text
                                                                       @click="submitFiles" v-bind:disabled="!files || files.length == 0">
                                                                    Upload
                                                                </v-btn>
                                                                <v-btn color="primary"
                                                                       text
                                                                       @click="cancelBrowsedFiles" v-bind:disabled="!files || files.length == 0">
                                                                    Cancel
                                                                </v-btn>
                                                                <v-btn color="primary"
                                                                       text
                                                                       @click="showUpload = false">
                                                                    Close
                                                                </v-btn>
                                                            </div>
                                                        </div>
                                                    </v-card-text>
                                                </v-card>
                                            </v-tab-item>
                                            <v-tab-item v-if="isMobile == false">
                                                <v-card>
                                                    <v-card-text>
                                                        <div>
                                                            <div class="row" v-if="selectedHospital" style="margin-top: 10px;">
                                                                <div class="col-12 cls-dictations" style="padding-top:0px;">
                                                                    <div class="row">
                                                                        <div class="col-12" style="padding: 0px;">
                                                                            <!--<audio-recorder ref="recorder" format="mp3"
                                                                            :attempts="100"
                                                                            :time="120"
                                                                            :show-upload-button="false"
                                                                            :before-recording="beforeRecordingCallback"
                                                                            :after-recording="afterRecordingCallback"
                                                                            :mic-failed="micFailedCallback"
                                                                            :bit-rate="320" />-->
                                                                            <xstek-audio-recorder :after-xstek-recording="afterXstekRecording"></xstek-audio-recorder>
                                                                        </div>
                                                                        <div class="cell col-12" v-if="!isRecordingSupported">
                                                                            Your browser doesn't support audio recording or you've blocked microphone access.
                                                                        </div>
                                                                    </div>
                                                                    <div class="row" v-show="uploading">
                                                                        <div class="col-md-12 text-center">
                                                                            <v-progress-linear v-model="uploading_progress"></v-progress-linear>
                                                                            <!--<v-progress-circular :size="42"
                                                                                                 :width="5"
                                                                                                 :rotate="90"
                                                                                                 :value="uploading_progress"
                                                                                                 color="green">
                                                                                {{ uploading_progress }}
                                                                            </v-progress-circular>-->
                                                                        </div>
                                                                    </div>
                                                                    <div class="row recorded-dictation-grid" style="height: 28vh; overflow:scroll; overflow-x: hidden;overflow-y: auto;">
                                                                        <div class="col-12">
                                                                            <!--<div class="row">
                                                                                <div class="col-12" style="background-color: #5bc0de;color: #fff;font-weight: 600;font-size: 9pt;padding: 5px 12px 5px 12px;">
                                                                                    <span>Note: Tick is for marking file urgent.</span>
                                                                                </div>
                                                                            </div>-->
                                                                            <div class="row recorded-grid-heading blue-header" style="font-weight: 600;font-size: 9pt;padding: 5px 12px 5px 12px;">
                                                                                <div class="col-3">
                                                                                    <span>Urgent</span><span style="text-align: center;display: inline-block;width: 79%;">File Name</span>
                                                                                </div>
                                                                                <div class="col-2" style="text-align: center;">
                                                                                    Dictator
                                                                                </div>
                                                                                <div class="col-1" style="text-align: center;">
                                                                                    Account
                                                                                </div>
                                                                                <div class="col-1" style="text-align: center;">
                                                                                    Patient No.
                                                                                </div>
                                                                                <div class="col-2" style="text-align: center;">
                                                                                    Patient First Name
                                                                                </div>
                                                                                <div class="col-2" style="text-align: center;">
                                                                                    Patient Last Name
                                                                                </div>
                                                                                <div class="col-1" style="text-align: center;">
                                                                                    Options
                                                                                </div>
                                                                            </div>
                                                                            <div class="row dictation" ref="recorded" v-on:click="selectDictation(index, $data)" v-for="(dictation, index) in recorded" :key="index">
                                                                                <div class="input-group col-3">
                                                                                    <div class="input-group-prepend">
                                                                                        <div class="input-group-text">
                                                                                            <input v-model="dictation.urgent" type="checkbox" title="Mark as urgent" />
                                                                                        </div>
                                                                                    </div>
                                                                                    <input name="fileName" placeholder="File Name" class="form-control form-control-sm" type="text" v-model.trim="dictation.fileName" />
                                                                                </div>
                                                                                <div class="col-2">
                                                                                    <input placeholder="Dictator Name" class="form-control form-control-sm" type="text" v-model.trim="dictation.cliName" readonly />
                                                                                </div>
                                                                                <div class="col-1">
                                                                                    <input class="form-control form-control-sm" type="text" v-model.trim="dictation.hosShortName" readonly />
                                                                                </div>
                                                                                <div class="col-1">
                                                                                    <input maxlength="50" placeholder="Patient No." class="form-control form-control-sm" type="text" v-model.trim="dictation.patientNo" />
                                                                                </div>
                                                                                <div class="col-2">
                                                                                    <input maxlength="50" placeholder="Patient First Name" class="form-control form-control-sm" type="text" v-model.trim="dictation.firstName" />
                                                                                </div>
                                                                                <div class="col-2">
                                                                                    <input maxlength="50" placeholder="Patient Last Name" class="form-control form-control-sm" type="text" v-model.trim="dictation.lastName" />
                                                                                </div>
                                                                                <div class="col-1" style="margin-top: 5px;text-align: center;">
                                                                                    <button type="button" class="btn-outline-none" v-on:click="playRecordedDictation(dictation)" title="Play Dictation">
                                                                                        <i class="far fa-play-circle" aria-hidden="true" style="cursor:pointer;"></i>
                                                                                    </button>
                                                                                    <button type="button" class="btn-outline-none" v-on:click="downloadRecordedDictation(dictation)" style="margin-left: 5px;" title="Download Dictation">
                                                                                        <i class="fas fa-download" style="cursor: pointer;"></i>
                                                                                    </button>
                                                                                    <button type="button" class="btn-outline-none" v-on:click="removeRecordedDictation(index, dictation)" style="margin-left: 5px;" title="Delete Dictation">
                                                                                        <i class="far fa-trash-alt" style="cursor: pointer;"></i>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-12 text-right">
                                                                    <v-btn color="primary"
                                                                           text
                                                                           @click="uploadDictation" v-bind:disabled="(!recorded || recorded.length == 0)">
                                                                        Upload
                                                                    </v-btn>
                                                                    <v-btn color="primary"
                                                                           text
                                                                           @click="uploadTabRecordCancel">
                                                                        Close
                                                                    </v-btn>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-card-text>
                                                </v-card>
                                            </v-tab-item>
                                        </v-tabs>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </div>
        </div>
        <div class="col-12 padding-t-b-0">
            <div class="row m-0 blue-header padding-top-0 padding-bottom-0 r-height">
                <div class="col-6 padding-bottom-0">
                    <div class="input-group" style="font-size:medium; font-weight: 600;">
                        XSTEK LIMTED<small style="margin-left: 15px; font-size: 10pt; font-weight: 400;margin-top: 3px;">{{welcome}}</small>
                    </div>
                </div>
                <div class="col-6 text-right padding-top-0" style="padding-right: 5px; padding-bottom: 5px;">
                    <div class="row">
                        <div class="col-12 padding-top-0 padding-bottom-0">
                            {{windowDate}}
                        </div>
                        <div class="col-12 padding-top-0 padding-bottom-0">
                            <button type="button" class="btn btn-sm btn-light" style="margin-right: 5px;" v-on:click="showChangePassword = true" v-bind:disabled="!clientID">
                                <i class="fas fa-key"></i><span>&nbsp;Change Password</span>
                            </button>
                            <button type="button" class="btn btn-sm btn-light" style="margin-right: 5px;" @click="showAlert = true" v-bind:disabled="!clientID">
                                <i class="fas fa-bell"></i><span>&nbsp;Alert</span>
                            </button>
                            <a href="/xstek-user-manual.pdf" target="_blank" class="btn btn-sm btn-light">
                                <i class="fas fa-info-circle"></i><span>&nbsp;Help</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-0 r-height" style="background-color: #FAFAFA; border-bottom: 3px solid #016BAB;">
                <div class="col-2" style="padding: 5px 0px 5px 5px;">
                    <v-select :items="accounts"
                              v-model="selectedHospital"
                              item-text="hosName"
                              solo
                              return-object
                              label="All Accounts">
                    </v-select>
                </div>
                <div class="col-2" style="padding: 5px 0px 5px 5px;">
                    <v-select :items="dictators"
                              v-model="selectedDictator"
                              item-text="cliName"
                              solo
                              return-object
                              label="All Dictators"></v-select>
                </div>
                <div class="col-8 traBtn text-right" style="padding-top: 5px; padding-bottom: 5px; padding-left: 10px; padding-right: 0;">
                    <button type="button" class="btn btn-sm btn-primary-outline" v-bind:disabled="!clientID" @click="showSearchDialog">
                        <i class="fas fa-search"></i>&nbsp;Search
                    </button>
                    <button ref="btnSave" type="button" class="btn btn-sm btn-warning" v-bind:disabled="!isTraId || isArchived" @click="saveTranscription">
                        <i class="fas fa-save"></i>&nbsp;Save
                    </button>
                    <button type="button" class="btn btn-sm btn-success" v-bind:disabled="!isTraId || isArchived" @click="approveTranscription">
                        <i class="fas fa-thumbs-up"></i>&nbsp;Approve
                    </button>
                    <button type="button" class="btn btn-sm btn-primary-outline" v-bind:disabled="!isTraId" @click="toggleLetter">
                        <i class="fab fa-expeditedssl"></i>&nbsp;Pending
                    </button>
                    <button type="button" class="btn btn-sm btn-primary-outline" v-bind:disabled="!isTraId || transcription.traPending" @click="copyContent">
                        <i class="fas fa-copy"></i>&nbsp;Copy
                    </button>
                    <button type="button" class="btn btn-sm btn-primary-outline" v-bind:disabled="!isTraId || transcription.traPending" @click="exportTranscription">
                        <i class="fas fa-file-export"></i>&nbsp;Export
                    </button>
                    <button type="button" class="btn btn-sm btn-primary-outline" v-bind:disabled="!isTraId" @click="qaTranscription">
                        <i class="fas fa-eye"></i>&nbsp;QA
                    </button>
                    <button type="button" class="btn btn-sm btn-primary-outline" title="Record/Upload Dictations" @click="showUploadEvent" v-bind:disabled="!clientID">
                        <i class="fas fa-microphone"></i>&nbsp;Record/&nbsp;<i class="fas fa-file-upload"></i>&nbsp;Upload
                    </button>
                    <button ref="logout" type="button" class="btn btn-sm btn-danger" @click="logout" v-show="clientID != null">
                        <i class="fas fa-sign-out-alt"></i>&nbsp;Logout
                    </button>
                    <button type="button" class="btn btn-sm btn-info" @click="showLogin = true" v-show="clientID == null">
                        <i class="fas fa-sign-out-alt"></i>&nbsp;Login
                    </button>
                </div>
            </div>
            <div class="row m-0">
                <div class="editor-page">
                    <div class="grid">
                        <div class="row">
                            <div class="col-sm-12 grid-option padding-top-0" style="margin-top:5px; padding-bottom: 5px;">
                                <div class="d-flex bd-highlight" style="padding: 0 0 0 5px;">
                                    <div class="p-2 flex-grow-1 bd-highlight" style="font-weight: 600;line-height: 30px;">{{showingRecords}}</div>
                                    <div class="p-2 bd-highlight">
                                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="downloadEvent" v-bind:disabled="!selected || selected.length == 0" title="Download">
                                            <i class="fas fa-download"></i>
                                        </button>
                                    </div>
                                    <div class="p-2 bd-highlight">
                                        <button type="button" class="btn btn-sm btn-outline-danger" @click="deleteEvent" v-bind:disabled="!selected || selected.length == 0" title="Delete">
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </div>
                                    <div class="p-2 bd-highlight">
                                        <button type="button" class="btn btn-sm btn-outline-success" style="margin-right: 5px;" @click="refresh" title="Refresh">
                                            <i class="fas fa-sync-alt"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 padding-top-0 traStatus" style="padding-bottom: 5px;">
                                <button class="btn btn-sm all active" title="Show All" @click="traStatusClickEvent('All')" style="padding-left: 5px;outline: none;">
                                    <span><i class="fas fa-file"></i>&nbsp;All Files</span>
                                </button>
                                <button class="btn btn-sm processing" title="Letters awaiting transcription" @click="traStatusClickEvent('Processing')">
                                    <img v-bind:src="baseURL+ 'images/processing.png'" alt="Letters awaiting transcription" style="width: 16px;margin-top: -6px;" />&nbsp;<span>{{status.processing}}</span>
                                </button>
                                <button class="btn btn-sm unapproved" title="Unapproved letters" @click="traStatusClickEvent('UnApproved')">
                                    <img v-bind:src="baseURL + 'images/new.png'" alt="Unapproved letters" style="width: 16px;margin-top: -6px;" />&nbsp;<span>{{status.unApproved}}</span>
                                </button>
                                <button class="btn btn-sm saved" title="Letters saved but not yet approved" @click="traStatusClickEvent('Saved')">
                                    <img v-bind:src="baseURL + 'images/saved.png'" alt="Letters saved but not yet approved" style="width: 16px;margin-top: -6px;" />&nbsp;<span>{{status.saved}}</span>
                                </button>
                                <button class="btn btn-sm approved" title="Approved letters" @click="traStatusClickEvent('Approved')">
                                    <img v-bind:src="baseURL + 'images/signed.png'" alt="Approved letters" style="width: 16px;margin-top: -6px;" />&nbsp;<span>{{status.approved}}</span>
                                </button>
                                <button class="btn btn-sm exported" title="Exported letters; These can now be deleted" @click="traStatusClickEvent('Exported')">
                                    <img v-bind:src="baseURL + 'images/signed_copied_exported.png'" style="width: 16px;margin-top: -6px;" />&nbsp;<span>{{status.exported}}</span>
                                </button>
                                <button class="btn btn-sm urgent" title="Urgent letters" @click="traStatusClickEvent('Urgent')">
                                    <img v-bind:src="baseURL + 'images/urgent.png'" style="width: 16px;margin-top: -4px;" />&nbsp;<span>{{status.urgent}}</span>
                                </button>
                            </div>
                            <div class="col-sm-12 padding-t-b-0">
                                <v-data-table dense
                                              :dark="false"
                                              :fixed-header="true"
                                              :headers="headers"
                                              :items="transcriptions"
                                              :options.sync="options"
                                              :items-per-page="pageSize"
                                              :server-items-length="totalRecords"
                                              @click:row="showDocument"
                                              show-select
                                              class="elevation-1"
                                              hide-default-footer>
                                    <template v-slot:header.data-table-select="headers">
                                        <input type="checkbox" @click="toggleAll" v-model="selectAll" style="margin-left: 3px;margin-top: 4.9px;" number />
                                    </template>
                                    <template v-slot:body="{ items }">
                                        <tbody>
                                            <tr v-bind:style="getTraIncompleteStyle(item)" ref="table" :key="index" v-for="(item, index) in items" @click="showDocument(item, index)" v:id="item.traId+'_'+index" :title="item.hosName">
                                                <td class="text-xs-center" v-bind:style="getTraIsDeleteStyle(item)">
                                                    <input v-bind:disabled="item.traId == 0 || item.traIsDelete" type="checkbox" @click.stop="stopTheEvent" v-model="selected" :value="index" :key="index" style="margin-left: 3px;margin-top: 5px;" number />
                                                </td>
                                                <td class="text-xs-left">
                                                    <img v-if="item.traPending" v-bind:src="baseURL + 'images/pending.png'" style="width: 16px; margin-top: -6px;" title="Pending" />
                                                    <img v-else-if="item.dicStatus < 3 || item.traId == 0" v-bind:src="baseURL + 'images/processing.png'" style="width: 16px; margin-top: -6px;" title="Processing" />
                                                    <img v-else-if="item.isSigned && item.isCopied" v-bind:src="baseURL + 'images/signed_copied_exported.png'" style="width: 16px; margin-top: -6px;" title="Signed and Copied" />
                                                    <img v-else-if="item.isSigned" v-bind:src="baseURL + 'images/signed.png'" style="width: 16px; margin-top: -6px;" title="Signed" />
                                                    <img v-else-if="item.isCopied" v-bind:src="baseURL + 'images/unsigned_copied_exported.png'" style="width: 16px; margin-top: -6px;" title="Copy" />
                                                    <img v-else-if="item.traSave" v-bind:src="baseURL + 'images/saved.png'" style="width: 16px; margin-top: -6px;" title="Saved" />
                                                    <img v-else v-bind:src="baseURL + 'images/new.png'" style="width: 16px; margin-top: -6px;" title="New" />
                                                </td>
                                                <td class="text-xs-center">{{ formatDateTime(item) }}</td>
                                                <td class="text-xs-center">
                                                    <span style="word-break: break-all;" v-if="!item.hosPatientNames || item.cliID == clientID">{{ item.dicSubject }}</span>
                                                    <span style="word-break: break-all;" v-else-if="item.hosPatientNames && !item.dicPatientNo">{{ item.dicSubject }}</span>
                                                </td>
                                                <td v-bind:name="item.traId" class="text-xs-center" :style="[item.hosColor != '' ? { 'background-color' : '' + item.hosColor + '', 'color': '#000000' } : { 'background-color' : 'transparent' }]">
                                                    <span style="word-break: break-all;">{{ item.dicPatientNo }}</span>
                                                </td>
                                                <td style="word-break: break-all;" class="text-xs-center">{{ item.drName }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                    <template v-slot:footer>
                                        <div v-if="totalRecords" id="paginationDiv" style="text-align:center">
                                            <b-pagination align="center"
                                                          v-model="options.page"
                                                          :total-rows="totalRecords"
                                                          :per-page="pageSize"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"
                                                          @change="pageChange"></b-pagination>
                                        </div>
                                    </template>
                                </v-data-table>
                            </div>
                        </div>
                    </div>
                    <div class="editor-page-content">
                        <div class="row r-height" style="background-color: #D9E9F8; margin-left: -10px;">
                            <div class="col-sm-4 padding-t-b-0" style="margin-top: 8px;">
                                <form>
                                    <div class="form-row">
                                        <label class="col-sm-2 col-form-label-sm">MRN#</label>
                                        <div class="col-sm-10">
                                            <div class="input-group">
                                                <input type="text" class="form-control form-control-sm" v-model="transcription.traPatientNo" />
                                                <div class="input-group-append">
                                                    <button type="button" class="btn btn-sm btn-primary-outline" @click="allLettersEvent" v-bind:disabled="!transcription || !transcription.traPatientNo"><i class="fas fa-list"></i>&nbsp;All Letters</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <label class="col-sm-2 col-form-label-sm">DOB:</label>
                                        <div class="col-sm-4">
                                            <input class="form-control form-control-sm" type="text" v-model="transcription.traDOBString" value="22/09/1983">
                                        </div>
                                        <label class="col-sm-2 col-form-label-sm" style="padding-right: 0;color: rgba(0, 0, 0, 0.87);">Dear:</label>
                                        <div class="col-sm-4" style="padding-left: 0;">
                                            <input class="form-control form-control-sm" type="text" v-model="transcription.traDear">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <label class="col-sm-2 col-form-label-sm">Subject:</label>
                                        <div class="col-sm-10">
                                            <input v-if="transcription.cliID == clientID || !transcription.hosPatientNames" class="form-control form-control-sm" type="text" v-model="transcription.traSubject">
                                            <input v-else-if="transcription.hosPatientNames && transcription.traPatientNo" class="form-control form-control-sm" :type="'password'" readonly="readonly" v-model="transcription.traSubject">
                                            <input v-else class="form-control form-control-sm" type="text" readonly="readonly" v-model="transcription.traSubject">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <label class="col-sm-2 col-form-label-sm">Note to Sec:</label>
                                        <div class="col-sm-10">
                                            <textarea rows="2" class="form-control form-control-sm" v-model="transcription.traNTS"></textarea>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <label class="col-sm-2 col-form-label-sm" style="word-break: keep-all;font-size: 9.5pt;padding-left: 0;">Recipient:</label>
                                        <div class="col-sm-10">
                                            <textarea rows="2" class="form-control form-control-sm" v-model="transcription.traRecipientAddress"></textarea>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="col-sm-4 padding-t-b-0" style="margin-top: 5px;">
                                <form>
                                    <div class="form-row">
                                        <div class="col-sm-3 col-form-label-sm">NHS#</div>
                                        <div class="col-sm-9">
                                            <div class="input-group">
                                                <input class="form-control form-control-sm" type="text" v-model="transcription.traNHSNo">
                                                <div class="input-group-append">
                                                    <button type="button" class="btn btn-sm btn-primary-outline" @click="allLettersNHSEvent" v-bind:disabled="!transcription || !transcription.traNHSNo"><i class="fas fa-list"></i>&nbsp;All Letters</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <label class="col-sm-3 col-form-label-sm" style="padding-left: 0;padding-right: 0;">Clinic Date:</label>
                                        <div class="col-sm-9">
                                            <input class="form-control form-control-sm" type="text" value="22/09/2019" v-model="transcription.traClinicDateString">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <label class="col-sm-3 col-form-label-sm">Clinic Ref:</label>
                                        <div class="col-sm-9">
                                            <input class="form-control form-control-sm" type="text" v-model="transcription.traClinicReference">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <label class="col-sm-3 col-form-label-sm">Notes to Dictator:</label>
                                        <div class="col-sm-9">
                                            <textarea rows="2" class="form-control form-control-sm" v-model="transcription.traNTD"></textarea>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <label class="col-sm-3 col-form-label-sm">Footer Block:</label>
                                        <div class="col-sm-9">
                                            <textarea rows="2" class="form-control form-control-sm" v-model="transcription.traFooterBlock"></textarea>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="col-sm-4 padding-t-b-0" style="margin-top: 5px;">
                                <form>
                                    <div class="form-row">
                                        <label class="col-sm-3 col-form-label-sm">Change Account:</label>
                                        <div class="col-sm-9">
                                            <v-select :items="traAccounts"
                                                      v-model="traHos"
                                                      item-text="hosName"
                                                      v-on:change="traHosChange"
                                                      solo
                                                      return-object
                                                      label="Accounts" :disabled="!isTraId || disabledChangeAccount">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <label class="col-sm-3 col-form-label-sm">Change Dictator:</label>
                                        <div class="col-sm-9">
                                            <v-select :items="traDictators"
                                                      v-model="traCli"
                                                      item-text="cliName"
                                                      solo
                                                      return-object
                                                      label="Dictators" :disabled="!isTraId || disabledChangeAccount">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <label class="col-sm-3 col-form-label-sm">Dictation:</label>
                                        <div class="col-sm-9">
                                            <input class="form-control form-control-sm" type="text" disabled="disabled" v-model="transcription.tooltip">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <label class="col-sm-3 col-form-label-sm">Document:</label>
                                        <div class="col-sm-9">
                                            <input class="form-control form-control-sm" type="text" disabled="disabled" v-model="transcription.traId">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-md-12" style="padding-top: 0;padding-bottom: 0;">
                                            <div class="d-flex bd-highlight">
                                                <div class="p-2 flex-grow-1 bd-highlight">
                                                    <span style="color: red;">Mark as Urgent</span>&nbsp;<input class="form-check-input form-control-sm" type="checkbox" value="" v-model="transcription.traIncomplete" id="markUrgent" style="margin-top: -3px;margin-left: 5px;">
                                                </div>
                                                <div class="p-2 bd-highlight">
                                                    <button v-bind:disabled="!transcription" title="Play Dictation" type="button" class="btn btn-sm btn-primary-outline" @click="getDictation"><i class="far fa-play-circle"></i>&nbsp;Play</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="row" style="display: none;">
                            <div class="col-sm-12 padding-t-b-0" style="padding-left: 3px;padding-right: 1px;">
                                <!-- The toolbar will be rendered in this container. -->
                                <div class="r-height" id="toolbar-container" style="width: 100%;"></div>
                                <!-- This container will become the editable. -->
                                <div id="editor" style="font-size: initial; background-color: #ffffff;"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 padding-t-b-0" style="padding-left: 2px;padding-right: 0;">
                                <!--v-model="transcription.traHtmlContent"-->
                                <editor 
                                        api-key="uzyvcjrnpyfwpzw0tj6t1bya502p8syx21kzdv4zj6vxg12z"
                                        tinymce-script-src="/tinymce/tinymce.min.js"
                                        @onInit="onInitEditor"
                                        ref="editor"
                                        :disabled="editorDisabled"
                                        :init="{
                                        referrer_policy: 'origin',
                                        fix_list_elements: true,
                                        indent_use_margin: true,
                                        remove_trailing_brs: false,
                                        nonbreaking_force_tab: true,
                                        cleanup: false,
                                        trim_span_elements : false,
                                        apply_source_formatting : true,
                                        font_formats: 'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Cambria =Cambria; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago;Kunstler Script=Kunstler Script; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats;Open Sans=open sans, sans-serif;',
                                        encoding: 'xml',
                                        entity_encoding: 'named+numeric+raw',
                                        entities: '160,nbsp',
                                        browser_spellcheck: true,
                                        height: 390,
                                        content_css: 'document',
                                        content_style: '@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap); p {margin: 0in;} a[name^=OLE_LINK] { display: none !important; } .mce-content-body .mce-item-anchor { display: none !important; }',
                                        menubar: false,
                                        valid_elements: '*[*]',
                                        setup : function(ed) {
                                            ed.on('keydown', function(evt) {
                                                if (evt.keyCode == 9) { // tab pressed
                                                    insertTab(ed, evt);
                                                    
                                                    return false;
                                                  }
                                            });
                                        },
                                        plugins: [
                                           'advlist autolink lists',
                                           'searchreplace visualblocks',
                                           'insertdatetime media table paste'
                                         ],
                                        toolbar:
                                           'undo redo | formatselect | fontselect | fontsizeselect | bold italic underline backcolor | \
                                            alignleft aligncenter alignright alignjustify | \
                                            bullist numlist | table'
                                        }">
                                </editor>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import moment from 'moment';
    import jQuery from 'jquery';
    //import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

    // Import component
    import Loading from 'vue-loading-overlay';
    import Multiselect from 'vue-multiselect'; /* source https://vue-multiselect.js.org/ */
    import XstekAudioRecorder from './XstekAudioRecorder';
    import Editor from '@tinymce/tinymce-vue';

    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { setTimeout } from 'timers';
    import Swal from 'sweetalert2'
    let $ = jQuery;
    export default {
        data() {
            return {
                baseURL: process.env.BASE_URL,
                headers: [
                    { text: '', align: 'center', sortable: false, value: 'traId', width: '16px' },
                    { text: 'Date', align: 'left', sortable: true, value: 'dicDateAndTime', width: '90px' },
                    { text: 'Subject', value: 'traSubject', width: '125px' },
                    { text: 'Patient', value: 'traPatientNo', width: '75px' },
                    { text: 'Dictator', value: 'drName', width: 'auto' }
                ],
                windowDate: moment().format('dddd, DD MMMM YYYY'),
                showLogin: false,
                searchDialog: false,
                isSearch: false,
                lastSortBy: null,
                lastSortDesc: null,
                options: {},
                showingRecords: null,
                totalRecords: null,
                transcriptions: [],
                transcription: { traHtmlContent: '', traNotFound: true },
                traHos: {},
                traCli: {},
                status: {},
                disabledWatchStatus: false,
                traStatus: 'All', // status will be 'All', 'Processing', 'UnApproved', 'Saved', 'Approved', 'Exported' & 'Urgent'
                traStatsClicked: false,
                xmlFileName: null,
                disableItemsPerPage: true,
                currentPage: 1,
                pageSize: 20,
                forceFetchFromDB: true,
                keywords: '',
                fromDate: '',
                menuFromDate: false,
                toDate: '',
                menuToDate: false,
                checkboxOWS: false,
                accountsWithoutAllOption: [],
                selectedSearchAccounts: [], // used in search
                isSearchPopupShowFirstTime: true,
                accounts: [],
                traAccounts: [],
                dictators: [],
                dictatorsWithoutAllOption: [],
                traDictators: [],
                patientName: true,
                patientNo: true,
                nhsNo: true,
                subject: true,
                documentContent: false,
                selectedDictator: null,
                selectedHospital: null,
                recordingHospital: null,
                recordingDictator: null,
                clientID: getStorageValue("clientID"),
                cliLoginID: getStorageValue("cliLoginID"),
                welcome: getStorageValue("welcome"),
                waitPromise: false,
                loading: true,
                fullPage: true, // show loader fullpage
                showInvalidUser: false,
                isSec: false,
                fullName: null,
                userId: null,
                userPassword: null,
                isTraId: false,
                selected: [],
                ckeditor: null,
                nextTraId: null,
                traHosAndClient: { hosID: '', cliID: '' },
                showAlert: false,
                supports: [],
                support: {},
                alertText: '',
                showChangePassword: false,
                changeOldPassword: null,
                changeNewPassword: null,
                changeConfirmPassword: null,
                invalidPasswordStrength: false,
                showUpload: false,
                files: [],
                dictationFiles: [],
                clinicDate: moment().format("DD/MM/YYYY"),
                defaultTabHash: 'tabUpload',
                showPlayDictation: false,
                dictationSrc: null,
                audioType: 'audio/mpeg',
                sFilterHospital: null,
                sFilterDictator: null,
                sFilterdictators: null,
                tabsOptions: { useUrlFragment: false, defaultTabHash: 'tabUpload' },
                recordUploadBtnDisabled: true,
                warningMessage: "Please upload recordings before closing. All recordings will be lost if system is logged out",
                recordingStartTime: null,
                isRecording: false,
                audioSource: null,
                recorded: [],
                isRecordingSupported: false,
                uploading: false,
                uploading_progress: 0,
                editorDisabled: false,
                disabledChangeAccount: false,
                isArchived: false,
                isMobile: false,
            }
        },
        beforeMount() {
            window.addEventListener("beforeunload", this.preventNav)
            this.$once("hook:beforeDestroy", () => {
                window.removeEventListener("beforeunload", this.preventNav);
            });
        },
        watch: {
            traStatus: {
                handler() {
                    $('button').removeClass('active');
                    $('.' + this.traStatus.toLowerCase()).addClass('active');
                },
                deep: false
            },
            options: {
                deep: true,
                handler(n, o) {
                    if (n.page !== o.page || n.sortBy !== o.sortBy || n.sortDesc !== o.sortDesc) {
                        this.fetchData();
                    }
                }
            },
            selectedHospital: {
                handler(newHospital) {
                    if (this.isDirty()) {
                        this.confirmSaveChanges().then(res => {
                            if (res.value) {
                                this.loading = true;
                                this.saveOnBeforeLeaving().then(() => {
                                    this.resetDirty();
                                    this.fetchDictators(newHospital);
                                }).catch(() => {
                                    this.loading = false;
                                });
                            } else {
                                this.resetDirty();
                                this.fetchDictators(newHospital);
                            }
                        });
                        return;
                    }
                    this.fetchDictators(newHospital);
                }
            },
            sFilterHospital: {
                handler(newHospital) {
                    this.loading = true;
                    this.loadDictators(newHospital.hosID).then((data) => {
                        let dictatorList = data.items;
                        if (dictatorList.length > 1) {
                            dictatorList.splice(0, 0, {
                                cliID: "",
                                cliName: "All Dictators",
                                foID: data.items[0].foID,
                                hosID: ""
                            });
                        }
                        this.sFilterdictators = dictatorList;
                        this.sFilterDictator = this.sFilterdictators[0];
                        this.loading = false;
                    }).catch(() => {
                        this.loading = false;
                    });
                }
            },
            selectedDictator: {
                handler() {
                    if (!this.isSearch) {
                        if (this.isDirty()) {
                            this.confirmSaveChanges().then((res) => {
                                if (res.value) {
                                    this.loading = true;
                                    this.saveOnBeforeLeaving().then(() => {
                                        this.resetDirty();
                                        this.traStatus = "All";
                                        this.getTranscriptionsOnChange(true);
                                    }).catch(() => {
                                        this.loading = false;
                                    });
                                }
                                else {
                                    this.resetDirty();
                                    this.traStatus = "All";
                                    this.getTranscriptionsOnChange(true);
                                }
                            });
                            return;
                        }
                        this.traStatus = "All";
                        this.getTranscriptionsOnChange(true);
                    }
                }
            },
            showLogin: {
                handler(newValue) {
                    if (newValue == true) {
                        this.loading = false;
                    }
                }
            },
            status: {
                handler() {
                    // only update stats
                    if (this.disabledWatchStatus) {
                        this.disabledWatchStatus = false;
                        return;
                    }
                    $(".grid table tbody tr").removeClass("selectedRowColor");
                    //this.ckeditor.setData("");
                    this.transcription = { traHtmlContent: '', traNotFound: true };
                    this.traHos = {};
                    this.traCli = {};
                    this.disabledChangeAccount = false;
                    this.isTraId = false;
                    this.isArchived = false;
                    this.showPlayDictation = false;
                    this.dictationSrc = null;
                    this.$refs.player.pause();
                    this.$refs.player.currentTime = 0;
                    if (this.totalRecords > 0) {
                        let from = ((this.options.page - 1) * this.options.itemsPerPage) + 1;
                        let to = (this.options.page * this.options.itemsPerPage);
                        if (to > this.totalRecords) {
                            to = this.totalRecords;
                        }
                        this.showingRecords = `Showing ${from} to ${to} of ${this.totalRecords}`;
                    }
                    else {
                        this.showingRecords = "No record found.";
                    }
                },
                deep: true
            },
            accounts: {
                handler(data) {
                    if (data) {
                        this.traAccounts = [];
                        for (let i = 0; i < data.length; i++) {
                            if (!data[i].hosID) {
                                continue;
                            }
                            this.traAccounts.push($.extend(true, {}, data[i]));
                        }
                    }
                }
            },
            showAlert: {
                handler(isShow) {
                    if (isShow) {
                        this.support = {};
                        this.alertText = "";
                    }
                }
            },
            showChangePassword: {
                handler(show) {
                    if (show) {
                        this.invalidPasswordStrength = false;
                        this.changeOldPassword = this.changeNewPassword = this.changeConfirmPassword = null;
                        $(".invalidPasswordStrength > div").removeClass("text-danger").removeClass("text-success");
                    }
                }
            },
            transcriptions: {
                handler() {
                    if (this.$refs.editor.editor) {
                        this.$refs.editor.editor.resetContent('');
                    }
                },
                deep: false
            }, // end watch

        },
        mounted() {
            // in case of user hit refresh button
            if (!this.axios.defaults.headers['Authorization'] && this.$store) {
                this.axios.defaults.headers['Authorization'] = `Bearer ${this.$store.state.token}`;
            }
            var self = this;
            this.$eventBus.$off('remove-record').$on('remove-record', () => {
                if (self.$refs.recorder.recordList && self.$refs.recorder.recordList.length > 0) {
                    self.recordUploadBtnDisabled = false;
                } else {
                    self.recordUploadBtnDisabled = true;
                }
            });
            this.fromDate = moment().subtract(5, "years").format("YYYY").toString() + "-01-01";
            this.toDate = moment().format("YYYY-MM-DD");
            this.supports.push({ supportText: 'Page not responding', id: 'Page not responding' });
            this.supports.push({ supportText: 'Page not loading fully', id: 'Page not loading fully' });
            this.supports.push({ supportText: 'System is slow', id: 'System is slow' });
            this.supports.push({ supportText: 'Other', id: 'Other' });
            this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        },
        updated() {

        },
        components: {
            Loading, Multiselect, XstekAudioRecorder, 'editor': Editor
        },
        computed: {
           
            // a computed getter
            selectAll: function () {
                // `this` points to the vm instance
                if (this.selected.length != this.transcriptions.length) {

                    return false;
                } else {

                    if (this.transcriptions.length != 0) {

                        return true;
                    } else {

                        return false;
                    }
                }
            },
            fromDateFormat() {
                let formatDate = this.fromDate ? moment(this.fromDate).format('DD-MM-YYYY') : '';
                return formatDate;
            },
            toDateFormat() {
                let formatDate = this.toDate ? moment(this.toDate).format('DD-MM-YYYY') : '';
                return formatDate;
            },
        },
        methods: {
            insertTab: function (ed, evt) {
                let tab = '<span style="mso-tab-count: 1;padding-left: 40px;display:inline-block;" contenteditable="false">&nbsp;&nbsp;&nbsp;&nbsp;</span>';
                ed.execCommand('mceInsertContent', false, tab); // inserts tab
                //ed.execCommand('Indent');
                evt.preventDefault();
                evt.stopPropagation();
            },
            preventNav(event) {
                if (this.recorded && this.recorded.length > 0) {
                    event.preventDefault();
                    event.returnValue = this.warningMessage;
                }
                else {
                    return;
                }
            },
            fetchDictators(hospital) {
                if (!this.isSearch) {
                    this.loading = true;
                    this.loadDictators(hospital.hosID).then((data) => {
                        let dictatorList = data.items;
                        this.dictatorsWithoutAllOption = $.extend(true, [], dictatorList);
                        if (dictatorList.length > 1) {
                            dictatorList.splice(0, 0, {
                                cliID: "",
                                cliName: "All Dictators",
                                foID: data.items[0].foID,
                                hosID: ""
                            });
                        }
                        this.dictators = dictatorList;
                        var isFound = false;
                        var cliID = this.selectedDictator ? this.selectedDictator.cliID : this.clientID;
                        $.each(this.dictators, (key, dictator) => {
                            if (dictator.cliID === cliID) {
                                this.selectedDictator = dictator;
                                isFound = true;
                                return false; // breaks
                            }
                        });
                        if (!isFound) {
                            this.selectedDictator = this.dictators[0];
                        }
                        this.loading = false;
                    }).catch(() => {
                        this.loading = false;
                    });
                }
            },
            fetchData() {
                if (this.selectedDictator != null) {
                    this.getTranscriptions(this.isSearch).then(data => {
                        let traVM = data;
                        this.totalRecords = traVM.totalRecords;
                        this.transcriptions = traVM.items;
                        this.status = traVM.status;
                        this.xmlFileName = traVM.xmlFileName;
                        sessionStorage.xmlFileName = this.xmlFileName;
                        this.$nextTick(() => {
                            this.selected = [];
                            if (this.transcriptions) {
                                for (var i = 0; i < this.transcriptions.length; i++) {
                                    if (this.nextTraId > 0 && this.transcriptions[i].traId == this.nextTraId) {
                                        // reset next traId
                                        this.nextTraId = 0;
                                        this.$refs.table[i].click();
                                        this.loading = false;
                                        break;
                                    } else if (this.transcriptions[i].traId > 0) {
                                        this.$refs.table[i].click();
                                        this.loading = false;
                                        break;
                                    }
                                }
                                if (this.loading) {
                                    this.loading = false;
                                }
                            }
                        });
                    }).catch((err) => {
                        this.loading = false;
                        alert(err);
                    });
                }
            },
            beforeRecordingCallback() {
                $('.ar-recorder__stop').prop('title', 'Stop recording');
            },
            afterXstekRecording($event) {
                try {
                    if (!this.recorded) {
                        this.recorded = [];
                    }
                    let duration = $event.duration.split(':');
                    let fileName = `${moment().format("DDMMYYYY-HHmmss")}`;
                    this.recorded.push({
                        "src": $event.url,
                        "blob": $event.blob,
                        "hosID": this.recordingHospital.hosID,
                        "hosShortName": this.recordingHospital.hosShortName,
                        "cliID": this.recordingDictator.cliID,
                        "cliName": this.recordingDictator.cliName,
                        "fileName": fileName,
                        "fileExtension": '.mp3',
                        "patientNo": null,
                        "firstName": null,
                        "lastName": null,
                        "urgent": false,
                        "duration": ((+duration[0]) * 60 + (+duration[1])) + 1,
                    });
                    // select last recorded voice
                    this.$nextTick(() => {
                        this.$refs.recorded[this.recorded.length - 1].click();
                        setTimeout(() => {
                            $(".recorded-dictation-grid").animate({ scrollTop: $('.recorded-dictation-grid').prop("scrollHeight") }, 1000);
                        }, 100);
                    });
                }
                finally {
                    $('.ar-recorder__stop').removeAttr('title');
                }
            },
            afterRecordingCallback($event) {
                try {
                    if (!this.recorded) {
                        this.recorded = [];
                    }
                    let duration = $event.duration.split(':');
                    let fileName = `${moment().format("DDMMYYYY-HHmmss")}`;
                    this.recorded.push({
                        "src": $event.url,
                        "blob": $event.blob,
                        "hosID": this.recordingHospital.hosID,
                        "hosShortName": this.recordingHospital.hosShortName,
                        "cliID": this.recordingDictator.cliID,
                        "cliName": this.recordingDictator.cliName,
                        "fileName": fileName,
                        "patientNo": null,
                        "firstName": null,
                        "lastName": null,
                        "urgent": false,
                        "duration": ((+duration[0]) * 60 + (+duration[1])) + 1,
                    });
                    // select last recorded voice
                    this.$nextTick(() => {
                        this.$refs.recorded[this.recorded.length - 1].click();
                        setTimeout(() => {
                            $(".recorded-dictation-grid").animate({ scrollTop: $('.recorded-dictation-grid').prop("scrollHeight") }, 1000);
                        }, 100);
                    });
                }
                finally {
                    $('.ar-recorder__stop').removeAttr('title');
                }
            },
            micFailedCallback(data) {
                this.$alert(`Unable to start your microphone or require https. Message: ${data}`, "Microphone");
            },
            stopTheEvent() {
                return;
            },
            toggleAll(event) {
                var selected = [];
                var i = 0;
                if (event.target.checked) {
                    this.transcriptions.forEach(function (item) {
                        if (item.traId > 0 && !item.traIsDelete) {
                            selected.push(i);
                        }
                        i++;
                    });
                }
                this.selected = selected;
            },
            saveOnBeforeLeaving() {
                let url = "api/transcription/save";
                this.transcription.traHtmlContent = this.$refs.editor.editor.getContent();
                this.transcription.traContent = this.$refs.editor.editor.getContent({ 'format': 'text' });
                this.transcription.xmlFileName = this.xmlFileName;
                this.transcription.cliLoginID = this.clientID;
                this.transcription.oldCliID = this.traHosAndClient.cliID;
                this.transcription.cliID = this.traCli.cliID;
                this.transcription.oldHosID = this.traHosAndClient.hosID;
                this.transcription.hosID = this.traHos.hosID;
                this.transcription.action = "save";
                let { page } = this.options;
                this.transcription.options = {
                    pageNo: page,
                    pageSize: this.pageSize,
                    xmlFilename: this.xmlFileName,
                    traStatus: this.traStatus,
                };
                return axios.post(url, this.transcription);
            },
            isDirty() {
                let ed = this.$refs.editor.editor;
                return ed.isDirty();
            },
            resetDirty() {
                let ed = this.$refs.editor.editor;
                if (ed.isDirty()) {
                    ed.save();
                }
            },
            confirmSaveChanges() {
                return Swal.fire({
                    title: 'Warning!',
                    text: "Please save changes before leaving the document",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#016BAB',
                    cancelButtonColor: '#dc3545',
                    confirmButtonText: 'Save',
                    cancelButtonText: 'Leave without saving'
                });
            },
            showDocument(item, index) {
                if (this.isDirty()) {
                    this.confirmSaveChanges().then((res) => {
                        if (res.value) {
                            this.loading = true;
                            this.saveOnBeforeLeaving().then(() => {
                                this.resetDirty();
                                this.getTranscriptionsStats();
                                this.$refs.table[index].click();
                            }).catch(() => {
                                this.loading = false;
                            });
                        }
                        else {
                            this.resetDirty();
                            this.$refs.table[index].click();
                        }
                    });
                    return;
                }
                this.transcription = {
                    traHtmlContent: '',
                    traNotFound: true
                };
                this.showPlayDictation = false;
                this.dictationSrc = null;
                this.$refs.player.pause();
                this.$refs.player.currentTime = 0;
                $(".selectedRowColor").removeClass("selectedRowColor");
                //this.ckeditor.setData("");
                if (event) {
                    if (event.target.nodeName.toLowerCase() != "tr") {
                        event.currentTarget.className = "selectedRowColor";
                    } else { // tr
                        event.target.className = "selectedRowColor";
                    }
                }
                this.traHos = {};
                this.traCli = {};
                this.disabledChangeAccount = false;
                if (item.traId > 0) {
                    this.getTranscriptionDetail(item).then((data) => {
                        this.transcription = data.item;
                        this.$refs.editor.editor.resetContent(this.transcription.traHtmlContent);
                        this.$refs.editor.editor.focus();
                        this.traHosAndClient.hosID = data.item.hosID;
                        this.traHosAndClient.cliID = data.item.cliID;
                        //this.ckeditor.setData(this.transcription.traHtmlContent);
                        this.isTraId = true;
                        this.isArchived = this.transcription.traIsDelete;
                        for (let i = 0; i < this.traAccounts.length; i++) {
                            let item = this.traAccounts[i];
                            if (item.hosID == this.transcription.hosID) {
                                this.traHos = { hosID: item.hosID, hosName: item.hosName };
                                break;
                            }
                        }
                        if (typeof this.traHos.hosID === 'undefined') {
                            this.disabledChangeAccount = true;
                            this.traHos = { hosID: this.transcription.hosID, hosName: this.transcription.hosName };
                            this.traCli = { cliID: this.transcription.cliID, cliName: this.transcription.cliName };
                        } else {
                            this.$nextTick(() => {
                                this.editorDisabled = this.transcription.traNotFound;
                                this.traHosChange(this.traHos);
                                this.loading = false;
                            });
                        }
                    }).catch((err) => {
                        this.loading = false;
                        this.onError(err);
                    });
                } else {
                    this.isTraId = false;
                    var transcription = $.extend(true, {}, item);
                    transcription.traHtmlContent = '';
                    transcription.traNotFound = true;
                    this.transcription = transcription;
                    this.$refs.editor.editor.resetContent(this.transcription.traHtmlContent);
                    this.editorDisabled = true;
                }
            },
            userLogin() {
                if ($.trim(this.userId) == '') {
                    this.$alert("Please enter user id");
                } else if ($.trim(this.userPassword) == '') {
                    this.$alert("Please enter user password");
                } else {
                    this.loading = true;
                    axios.post('api/account', {
                        'cliLoginId': this.userId,
                        'cliPassword': this.userPassword
                    }).then((res) => {
                        if (res.data) {
                            this.windowDate = moment().format('dddd, DD MMMM, YYYY ZZ');
                            this.showLogin = false;
                            this.showInvalidUser = false;
                            this.clientID = res.data.cliID;
                            this.cliLoginID = res.data.cliLoginId;
                            this.isSec = res.data.isSec;
                            this.welcome = "Welcome " + res.data.fullName;
                            setStorageValue("clientID", this.clientID);
                            setStorageValue("cliLoginID", this.cliLoginID);
                            setStorageValue("welcome", this.welcome);
                            let self = this;
                            this.loadHosptials().then(data => {
                                let accounts = data.items;
                                if (accounts.length > 1) {
                                    accounts.splice(0, 0, { hosID: "", hosName: "All Accounts" });
                                }
                                self.accounts = accounts;
                                self.selectedHospital = self.accounts[0];
                            });
                        } else {
                            this.showInvalidUser = true;
                            this.loading = false;
                        }
                    }, () => {
                        this.loading = false;
                    });
                }
            },
            logout() {
                if (this.isDirty()) {
                    this.confirmSaveChanges().then(res => {
                        if (res.value) {
                            this.loading = true;
                            this.saveOnBeforeLeaving().then(() => {
                                this.loading = false;
                                this.resetDirty();
                                this.logout();
                            }).finally(() => { this.loading = false; });
                        } else {
                            this.resetDirty();
                            this.logout();
                        }
                    });
                    return;
                }
                var externalLogin = getStorageValue('externalLogin');
                if (this.recorded && this.recorded.length > 0) {
                    Swal.fire({
                        title: 'Warning!',
                        text: "There are recordings waiting to be uploaded. All recordings will be lost if you continue to log off",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#016BAB',
                        cancelButtonColor: '#dc3545',
                        confirmButtonText: 'Continue to Log Off',
                        cancelButtonText: 'Cancel'
                    }).then((result) => {
                        if (result.value) {
                            this.$store.dispatch('logout').then(() => {
                                if (externalLogin) {
                                    window.location.href = externalLogin;
                                } else {
                                    this.$router.push('/login');
                                }
                            });
                        }
                    });
                }
                else {
                    this.$store.dispatch('logout').then(() => {
                        if (externalLogin) {
                            window.location.href = externalLogin;
                        } else {
                            this.$router.push('/login');
                        }
                    });
                }
            },
            refresh() {
                if (this.isDirty()) {
                    this.confirmSaveChanges().then(res => {
                        if (res.value) {
                            this.loading = true;
                            this.saveOnBeforeLeaving().then(() => {
                                this.resetDirty();
                                this.traStatus = "All";
                                this.checkboxOWS = false;
                                this.getTranscriptionsOnChange(true);
                            }).finally(() => { this.loading = false; });
                        } else {
                            this.resetDirty();
                            this.traStatus = "All";
                            this.checkboxOWS = false;
                            this.getTranscriptionsOnChange(true);
                        }
                    });
                    return;
                }
                this.traStatus = "All";
                this.checkboxOWS = false;
                this.getTranscriptionsOnChange(true);
            },
            traStatusClickEvent(traStatus) {
                // this.traStatsClicked = true;
                if (this.isDirty()) {
                    this.confirmSaveChanges().then(res => {
                        if (res.value) {
                            this.loading = true;
                            this.saveOnBeforeLeaving().then(() => {
                                this.resetDirty();
                                this.traStatusClickEvent(traStatus);
                            }).finally(() => { this.loading = false; });
                        } else {
                            this.resetDirty();
                            this.traStatusClickEvent(traStatus);
                        }
                    });
                    return;
                }
                this.traStatus = traStatus;
                this.getTranscriptionsOnChange(false);
            },
            getTranscriptionsOnChange(forceToFetchFromDB) {
                this.transcription = {
                    traHtmlContent: '',
                    traNotFound: true
                };
                if ($.trim(this.clientID) == '') {
                    this.showLogin = true;
                    this.loading = false;
                    return;
                }
                this.forceFetchFromDB = forceToFetchFromDB;
                let newOptions = this.options;
                newOptions.page = 1;
                newOptions.sortBy[0] = null;
                newOptions.sortDesc[0] = null;
                let willWatchEventFire = false;
                if (this.options.page != newOptions.page || this.options.sortBy[0] != newOptions.sortBy[0] || this.options.sortDesc[0] != newOptions.sortDesc[0]) {
                    willWatchEventFire = true;
                }
                this.options = newOptions;
                if (willWatchEventFire == false) {
                    this.getTranscriptions(this.isSearch).then(data => {
                        let traVM = data;
                        this.totalRecords = traVM.totalRecords;
                        this.transcriptions = traVM.items;
                        this.status = traVM.status;
                        this.xmlFileName = traVM.xmlFileName;
                        sessionStorage.xmlFileName = this.xmlFileName;
                        this.$nextTick(() => {
                            this.selected = [];
                            if (this.transcriptions) {
                                for (var i = 0; i < this.transcriptions.length; i++) {
                                    if (this.transcriptions[i].traId > 0) {
                                        this.$refs.table[i].click();
                                        break;
                                    }
                                }
                            }
                        });
                    }).catch((err) => { this.onError(err); }).finally(() => { setTimeout(() => { this.loading = false; }, 100); });
                }
            },
            getTranscriptions(isSearch, isExportCSV) {
                if ($.trim(this.cliLoginID) == '') {
                    this.showLogin = true;
                    this.loading = false;
                    return;
                }
                this.loading = true;
                return new Promise((resolve, reject) => {
                    const { sortBy, sortDesc, page } = this.options;
                    let needSorting = false;
                    if (sortBy[0]) {
                        if (this.lastSortBy != sortBy[0] || this.lastSortDesc != sortDesc[0]) {
                            needSorting = true;
                            this.lastSortBy = sortBy[0];
                            this.lastSortDesc = sortDesc[0];
                        }
                    } else if (this.lastSortBy || this.lastSortDesc) {
                        this.lastSortBy = null;
                        this.lastSortDesc = null;
                        needSorting = true; // reset to default sorting
                    }
                    if (!needSorting && (isSearch || this.traStatsClicked)) {
                        needSorting = true;
                    }

                    // reset traStatsClicked flag
                    this.traStatsClicked = false;

                    var hosID = (this.selectedHospital == null) ? null : this.selectedHospital.hosID;
                    //var hosID = null;
                    if (isExportCSV == true) {
                        this.forceFetchFromDB = true;
                    }
                    var data = {
                        'forceFetchFromDB': this.forceFetchFromDB,
                        'pageNo': page,
                        'pageSize': this.pageSize,
                        'sortBy': sortBy[0],
                        'sortDesc': sortDesc[0] == null ? false : sortDesc[0],
                        'needSorting': needSorting,
                        'xmlFilename': this.xmlFileName,
                        'cliID': this.selectedDictator == null ? null : this.selectedDictator.cliID,
                        'cliIDs': this.getCliIDs(),
                        'cliLoginID': this.clientID,
                        'hosID': hosID,
                        'hosIDs': this.getHosIDs(isSearch),
                        'traStatus': this.traStatus,
                        'isSearch': isSearch,
                        'searchVM': {
                            'keyword': this.keywords,
                            'organisationWideSearch': this.checkboxOWS,
                            'from': this.fromDate,
                            'to': this.toDate,
                            'patientName': this.patientName,
                            'patientNo': this.patientNo,
                            'nhsNo': this.nhsNo,
                            'subject': this.subject,
                            'selectedAccount': hosID,
                            'selectedDictator': this.selectedDictator == null ? null : this.selectedDictator.cliID,
                            'documentContent': this.documentContent,
                            'exportCSV': isExportCSV
                        }
                    };

                    let responseType = (isExportCSV == true) ? 'blob' : 'json';
                    axios.post('api/transcription', data, {
                        timeout: ((1000 * 60) * 2),
                        responseType: responseType
                    }).then((response) => {
                            this.forceFetchFromDB = false;
                            this.isSearch = false;
                            resolve(response.data);
                        })
                        .catch((e) => {
                            reject(e);
                        });
                });
            },
            formatDateTime(item) {

                return moment(item.dicDateAndTime, ["YYYY-MM-DDTHH:mm:ss", "YYYY/MM/DDTHH:mm:ss"]).format("DD/MM/YY HH:mm");
            },
            getHosColorStyle(item) {

                return { 'background-color': item.hosColor, 'color': '#000000' };
            },
            getTraIsDeleteStyle(item) {

                return item.traIsDelete ? { 'background-color': '#4D4D4D' } : { 'background-color': 'transparent' };
            },
            getTraIncompleteStyle(item) {

                return item.traIncomplete ? { 'color': 'red' } : { 'color': 'inherit' };
            },
            disableChangeSelect(traId) {

                return traId == 0;
            },
            loadHosptials() {

                return new Promise((resolve, reject) => {
                    axios.get(`api/transcription/loadHosptials?cliID=${this.clientID}&isSec=false`)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((e) => {
                            if (e.response.status === 401) {
                                this.logout(); // now store should be accessible
                            }
                            reject(e);
                        });
                });
            },
            getHosIDs(isSearch) {

                var hosIDs = [];
                if (isSearch) {
                    this.selectedSearchAccounts.forEach(function (account) {
                        if (account.hosID) {
                            hosIDs.push("'" + account.hosID + "'");
                        }
                    });
                } else {
                    this.accounts.forEach(function (account) {
                        if (account.hosID) {
                            hosIDs.push("'" + account.hosID + "'");
                        }
                    });
                }
                return hosIDs;
            },
            getCliIDs() {

                var cliIDs = [];
                this.dictators.forEach(function (dictator) {
                    if (dictator.cliID) {
                        cliIDs.push("'" + dictator.cliID + "'")
                    }
                });
                return cliIDs;
            },
            loadDictators(hosID) {

                return new Promise((resolve, reject) => {
                    axios.get(`api/transcription/loaddictators?cliID=${this.clientID}&hosID=${hosID}`)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((e) => {
                            reject(e);
                        });
                });
            },
            resetSearch() {

                this.keywords = "";
                this.fromDate = moment().subtract(5, "years").format("YYYY").toString() + "-01-01";
                this.toDate = moment().format("YYYY-MM-DD");
                this.patientName = true;
                this.sFilterHospital = null;
                this.sFilerDictator = null;
                this.patientNo = true;
                this.documentContent = false;
                this.subject = true;
                this.nhsNo = true;
                this.checkboxOWS = false;
            },
            searchTransactions() {
                this.selectedHospital = this.sFilterHospital;
                this.selectedDictator = this.sFilterDictator;
                this.searchDialog = false;
                this.isSearch = true;
                this.traStatus = "All";
                this.getTranscriptionsOnChange(true);
            },
            searchAndExportReport() {
                this.selectedHospital = this.sFilterHospital;
                this.selectedDictator = this.sFilterDictator;
                this.getTranscriptions(true, true).then((data) => {
                    this.searchDialog = false;
                    this.forceFetchFromDB = false;
                    setTimeout((data) => {
                        let filename = prompt("Please enter download filename", "search-data")
                        if (!filename) {
                            filename = "search-data";
                        }
                        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
                        const url = window.URL.createObjectURL(
                            new Blob([data], { type: "application/vnd.ms-excel" })
                        );
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", `${filename}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                    }, 100, data);
                });
            },
            checkPasswordStrength(password) {

                // Validate lowercase letters
                var lowerCaseLetters = /[a-z]/g;
                if (lowerCaseLetters.test(password)) {
                    $('.letter').removeClass('text-danger').addClass('text-success');
                } else {
                    $('.letter').addClass('text-danger').removeClass('text-success');
                }

                // Validate capital letters
                var upperCaseLetters = /[A-Z]/g;
                if (upperCaseLetters.test(password)) {
                    $('.capital').removeClass('text-danger').addClass('text-success');
                } else {
                    $('.capital').addClass('text-danger').removeClass('text-success');
                }
                // Validate special character

                var specialcharacter = /[!@#$%^&*(),.?":{}|<>]/g;
                if (specialcharacter.test(password)) {
                    $('.specialCharacters').removeClass('text-danger').addClass('text-success');
                } else {
                    $('.specialCharacters').addClass('text-danger').removeClass('text-success');
                }

                // Validate numbers
                var numbers = /[0-9]/g;
                if (numbers.test(password)) {
                    $('.number').removeClass('text-danger').addClass('text-success');
                } else {
                    $('.number').addClass('text-danger').removeClass('text-success');
                }

                // Validate length
                if (password.length >= 8) {
                    $('.length').removeClass('text-danger').addClass('text-success');
                } else {
                    $('.length').addClass('text-danger').removeClass('text-success');
                }

                var hasError = $(".invalidPasswordStrength div.text-danger");
                if (hasError.length > 0) {
                    setTimeout(() => {
                        this.invalidPasswordStrength = true;
                    }, 100);
                }
                else {
                    setTimeout(() => {
                        this.invalidPasswordStrength = false;
                    }, 500);
                }

            },
            newPasswordChange() {
                this.checkPasswordStrength(this.changeNewPassword);
            },
            changePassword() {
                var regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
                var result = regex.test(this.changeNewPassword);
                if (!result) {
                    this.invalidPasswordStrength = true;
                    return;
                }
                this.loading = true;
                axios.post('api/account/changepassword', {
                    'cliID': this.cliLoginID,
                    'oldPassword': this.changeOldPassword,
                    'password': this.changeNewPassword,
                    'cliStrongPassword': true
                }).then((response) => {
                    if (response.data == true) {
                        this.$alert("Password change successfully.", "Change Password", "success");
                        this.showChangePassword = !this.showChangePassword;
                        if (this.isDirty()) {
                            this.confirmSaveChanges().then((res) => {
                                if (res.value) {
                                    this.loading = true;
                                    this.saveOnBeforeLeaving().then(() => {
                                        this.$refs.logout.click();
                                    }).finally(() => {
                                        this.loading = false;
                                    });
                                }
                                else {
                                    this.resetDirty();
                                    this.$refs.logout.click();
                                }
                            });
                            return;
                        }
                        this.$refs.logout.click();
                    } else {
                        this.$alert("Invalid old password.", "Change Password", "error");
                    }
                    this.$nextTick(() => {
                        this.loading = false;
                    });
                }).catch(() => {
                    this.loading = false;
                    this.$alert("Unable to update password, Please try again.", "Change Password", "info");
                });
            },
            showSearchDialog() {
                if (this.isDirty()) {
                    this.confirmSaveChanges().then(res => {
                        if (res.value) {
                            this.loading = true;
                            this.saveOnBeforeLeaving().then(() => {
                                this.loading = false;
                                this.resetDirty();
                                this.showSearchDialog();
                            }).finally(() => { this.loading = false; });
                        } else {
                            this.resetDirty();
                            this.showSearchDialog();
                        }
                    });
                    return;
                }
                if (!this.sFilterdictators) {
                    this.sFilterdictators = $.extend(true, [], this.dictators);
                }
                if (this.isSearchPopupShowFirstTime) {
                    this.selectedSearchAccounts = this.accountsWithoutAllOption;
                    //this.accountsWithoutAllOption.forEach((acc) => {
                    //    if (acc.accDefault) {
                    //        this.selectedSearchAccounts.push(acc);
                    //    }
                    //});
                    this.isSearchPopupShowFirstTime = false;
                }
                this.sFilterHospital = this.accounts[0];
                this.sFilterDictator = this.sFilterdictators[0];
                this.searchDialog = true;
            },
            getTranscriptionDetail(item) {
                this.loading = true;
                return new Promise((resolve, reject) => {
                    axios.get(`api/transcription/gettranscriptiondetail?traId=${item.traId}&cliId=${item.cliID}&source=0&xmlFile=${this.xmlFileName}&tPages=${this.totalRecords}&hosID=${item.hosID}&loginID=${this.cliLoginID}&hCliID=${this.clientID}`)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((e) => {
                            reject(e);
                        });
                });
            },
            sendAlert() {
                this.loading = true;
                this.axios.post('api/client/alert', {
                    "clientID": this.clientID,
                    "subject": this.support.supportText,
                    "body": this.alertText
                }).then((res) => {
                    if (res.data.hasError) {
                        this.$alert(res.data.errorMessage, "Alert", "error");
                    } else {
                        this.showAlert = false;
                    }
                    this.loading = false;
                }).catch(() => { this.loading = false; });
            },
            resetAlert() {
                this.support = {};
                this.alertText = "";
            },
            toggleLetter() {
                this.loading = true;
                let data = {
                    'xmlFileName': this.xmlFileName,
                    'traId': this.transcription.traId,
                    'cliID': this.transcription.cliID,
                    'cliLoginID': this.clientID
                };
                axios.post('api/transcription/toggleletter', data)
                    .then((response) => {
                        this.transcription.traPending = response.data.traPending;
                        for (let i = 0; i < this.transcriptions.length; i++) {
                            let trans = this.transcriptions[i];
                            if (trans.traId == this.transcription.traId) {
                                trans.traPending = this.transcription.traPending;
                                break;
                            }
                        }
                        this.$nextTick(() => {
                            this.loading = false;
                        });
                    }).catch(() => { this.loading = false; });
            },
            saveTranscription() {
                this.updateTranscription("save");
            },
            approveTranscription() {
                this.updateTranscription("approve");
            },
            exportTranscription() {
                this.updateTranscription("export");
            },
            qaTranscription() {
                this.loading = true;
                axios.post('api/transcription/qa', { 'traId': this.transcription.traId })
                    .then(() => {
                        // https://vuejsexamples.com/simple-alert-for-vue-js/
                        this.$alert("Document is marked for QA.");
                        this.loading = false;
                    }).catch(() => { this.loading = false; });
            },
            copyContent() {
                const ed = this.$refs.editor.editor;
                ed.selection.select(ed.getBody(), true);
                ed.execCommand("copy");
                this.updateTranscription("copy");
                //let el = document.getElementById("editor");
                //var range = document.createRange();
                //range.selectNodeContents(el);
                //var sel = window.getSelection();
                //sel.removeAllRanges();
                //sel.addRange(range);
                //var self = this;
                //setTimeout(function() {
                //    document.execCommand('copy');
                //    self.updateTranscription("copy");
                //}, 0);
            },
            getTranscriptionsStats() {
                axios.post('api/transcription/gettranscriptionsstats', { 'xmlFileName': this.xmlFileName }).then((res) => {
                    this.disabledWatchStatus = true;
                    this.status = res.data;
                });
            },
            updateTranscription(action) {
                let url = "api/transcription/save";
                if ($.trim(action).toLowerCase() == "copy") {
                    url = "api/transcription/copy";
                } else if ($.trim(action).toLowerCase() == "save") {
                    url = "api/transcription/save";
                } else if ($.trim(action).toLowerCase() == "export") {
                    url = "api/transcription/export";
                } else if ($.trim(action).toLowerCase() == "approve") {
                    url = "api/transcription/approve";
                }
                this.loading = true;
                this.transcription.traContent = this.$refs.editor.editor.getContent({ format: 'text' });
                this.transcription.traHtmlContent = this.$refs.editor.editor.getContent();
                this.transcription.xmlFileName = this.xmlFileName;
                this.transcription.cliLoginID = this.clientID; //this.cliLoginID;
                //this.transcription.traHtmlContent = this.ckeditor.getData();
                this.transcription.oldCliID = this.traHosAndClient.cliID;
                this.transcription.cliID = this.traCli.cliID;
                this.transcription.oldHosID = this.traHosAndClient.hosID;
                this.transcription.hosID = this.traHos.hosID;
                this.transcription.action = $.trim(action).toLowerCase();
                let { page } = this.options;
                this.transcription.options = {
                    pageNo: page,
                    pageSize: this.pageSize,
                    xmlFilename: this.xmlFileName,
                    traStatus: this.traStatus,
                };
                axios.post(url, this.transcription)
                    .then((res) => {
                        this.$nextTick(() => {
                            this.resetDirty();
                        });
                        this.transcription = res.data;
                        for (let i = 0; i < this.transcriptions.length; i++) {
                            let trans = this.transcriptions[i];
                            if (trans.traId == this.transcription.traId) {
                                trans.traPending = this.transcription.traPending;
                                trans.dicStatus = this.transcription.dicStatus;
                                trans.isCopied = this.transcription.isCopied;
                                trans.isSigned = this.transcription.isSigned;
                                trans.traSave = this.transcription.traSave;
                                trans.hosID = this.transcription.hosID;
                                trans.hosColor = this.transcription.hosColor;
                                trans.hosPatientNames = this.transcription.hosPatientNames;
                                trans.cliID = this.transcription.cliID;
                                trans.traPatientNo = this.transcription.traPatientNo;
                                if (!trans.isDicPatientNo) {

                                    trans.dicPatientNo = trans.traPatientNo;
                                }
                                if ($.trim(trans.dicPatientNo) == '') {
                                    trans.dicPatientNo = this.transcription.traNHSNo;
                                }
                                trans.traSubject = this.transcription.traSubject;
                                if (!trans.isDicSubject) {

                                    trans.dicSubject = trans.traSubject;
                                }
                                trans.traIncomplete = this.transcription.traIncomplete;
                                this.traHosAndClient.cliID = this.transcription.cliID;
                                this.traHosAndClient.hosID = this.transcription.hosID;
                                if (this.transcription.action == 'export') {
                                    var traName = this.transcription.traName;
                                    var extension = this.transcription.hosExportFormat;
                                    this.loading = true;
                                    this.axios({
                                        url: `api/transcription/download?traId=${this.transcription.traId}&fileName=${this.xmlFileName}&extension=${extension}`,
                                        method: 'GET',
                                        responseType: 'blob'
                                    }).then((response) => {
                                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                                        var fileLink = document.createElement('a');

                                        fileLink.href = fileURL;
                                        if (extension != '.doc') {
                                            var i = traName.lastIndexOf(".doc")
                                            traName = traName.substring(0, i) + extension;
                                        }
                                        fileLink.setAttribute('download', traName);
                                        document.body.appendChild(fileLink);
                                        fileLink.click();
                                    }).finally(() => { this.loading = false; });
                                }
                                break;
                            }
                        }
                        this.$nextTick(() => {

                            // update letter stats count
                            this.getTranscriptionsStats();
                            if (this.transcription.hosColor) {
                                $("td[name='" + this.transcription.traId + "']").css("background-color", this.transcription.hosColor);
                            } else {
                                $("td[name='" + this.transcription.traId + "']").css("background-color", 'transparent');
                            }
                            let { page } = this.options;
                            this.nextTraId = this.transcription.options.nextTraId;
                            if (this.nextTraId > 0) {
                                if (page == this.transcription.options.nextPageNo) {
                                    if (this.transcriptions) {
                                        let isFound = false;
                                        for (var i = 0; i < this.transcriptions.length; i++) {
                                            if (this.transcriptions[i].traId == this.transcription.options.nextTraId) {
                                                isFound = true;
                                                this.$refs.table[i].click();
                                                break;
                                            }
                                        }
                                        if (!isFound) {
                                            this.fetchData();
                                        }
                                    }
                                } else {
                                    this.options.page = this.transcription.options.nextPageNo;
                                    this.fetchData();
                                }
                            }
                            else if (this.transcription.options.traStatus == "UnApproved") {
                                this.fetchData();
                            }
                            this.loading = false;
                        });
                    }).catch((err) => {
                        this.loading = false;
                        this.onError(err);
                    });
            },
            deleteEvent() {
                let confirmed = confirm('Are you sure you want to delete?');
                let needNewDeleteConfirmation = false;
                if (confirmed) {
                    var traIds = [];
                    for (var i = 0; i < this.selected.length; i++) {
                        let selectedTranscription = this.transcriptions[this.selected[i]];
                        traIds.push(selectedTranscription.traId);
                        if (!selectedTranscription.isSigned && !selectedTranscription.isCopied) {
                            needNewDeleteConfirmation = true;
                        }
                    }
                    if (needNewDeleteConfirmation) {
                        confirmed = confirm('Are you sure you want to delete unprocessed letter?');
                    }
                    if (confirmed) {
                        this.loading = true;
                        axios.post('api/transcription/delete', {
                            "selected": this.selected,
                            "traIds": traIds,
                            "clientID": this.clientID,
                            "xmlFileName": this.xmlFileName
                        }).then((res) => {
                            if (res.data) {
                                let deleteTranscriptions = res.data;
                                for (var i = 0; i <= deleteTranscriptions.selected.length; i++) {
                                    let index = deleteTranscriptions.selected[i];
                                    if (typeof this.transcriptions[index] !== 'undefined') {
                                        this.transcriptions[index].traIsDelete = "true";
                                    }
                                }
                            }
                            this.$nextTick(() => { this.loading = false; });
                        }).catch((err) => {
                            this.loading = false;
                            this.onError(err);
                        })
                    }
                }
            },
            downloadEvent() {
                var trans = [];
                for (var i = 0; i < this.selected.length; i++) {
                    let selectedTranscription = this.transcriptions[this.selected[i]];
                    if (selectedTranscription.traId > 0) {
                        trans.push({ "cliID": selectedTranscription.cliID, "traName": selectedTranscription.traName });
                    }
                }
                this.loading = true;
                this.axios({
                    url: 'api/transcription/downloads',
                    method: 'POST',
                    responseType: 'blob',
                    data: trans
                }).then((response) => {

                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    var fileName = (this.selected.length == 1) ? (this.transcriptions[this.selected[0]].traName) : (this.clientID + '-' + moment().format('YYYY-MMM-DD-hhmmss') + '.zip');
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.$nextTick(() => {
                        this.loading = false;
                    });
                }).catch(() => { this.loading = false; });
            },
            showUploadEvent() {
                if (this.isDirty()) {
                    this.confirmSaveChanges().then(res => {
                        if (res.value) {
                            this.loading = true;
                            this.saveOnBeforeLeaving().then(() => {
                                this.loading = false;
                                this.resetDirty();
                                this.showUploadEvent();
                            }).finally(() => { this.loading = false; });
                        } else {
                            this.resetDirty();
                            this.showUploadEvent();
                        }
                    });
                    return;
                }
                // by default accDefault account is selected
                let defaultAccount = this.$_.find(this.accounts, (acc) => { return acc.accDefault == true; })
                if (defaultAccount) {
                    this.recordingHospital = defaultAccount;
                }
                else {
                    for (let i = 0; i < this.accounts.length; i++) {
                        if (this.accounts[i].hosID != '') {
                            this.recordingHospital = this.accounts[i];
                            break;
                        }
                    }
                }
                this.recordingHospitalChange(this.recordingHospital);

                // by default login dictator is selected
                //let defaultDictator = this.$_.find(this.dictators, (dic) => { return dic.cliID == this.clientID });
                //if (defaultDictator) {
                //    this.recordingDictator = defaultDictator;
                //}
                //else {
                //    for (let i = 0; i < this.dictators.length; i++) {
                //        if (this.dictators[i].cliID != '') {
                //            this.recordingDictator = this.dictators[i];
                //            break;
                //        }
                //    }
                //}

                //if (this.$refs.recorder && this.$refs.recorder.recordList && this.$refs.recorder.recordList.length > 0) {
                //    this.recordUploadBtnDisabled = false;
                //} else {
                //    this.recordUploadBtnDisabled = true;
                //}

                this.clinicDate = moment().format("DD/MM/YYYY");
                this.tabsOptions.defaultTabHash = 'tabUpload';
                this.showUpload = true;
            },
            uploadTabChanged(selectedIndex) {
                if (selectedIndex == 1) {
                    this.$nextTick().then(() => {
                        setTimeout(() => {
                            $('.ar-recorder .ar-icon:first-child').prop('title', 'Start recording');
                            $('.ar-recorder__duration').css('margin-top', '31px');
                        }, 0);
                    });
                }
            },
            uploadTabRecordCancel() {

                if (this.recorded && this.recorded.length > 0) {
                    Swal.fire({
                        title: 'Warning!',
                        text: this.warningMessage,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#016BAB',
                        cancelButtonColor: '#dc3545',
                        confirmButtonText: 'Continue to Close',
                        cancelButtonText: 'Cancel'
                    }).then((result) => {
                        if (result.value) {
                            this.showUpload = false;
                        }
                    });
                } else {
                    this.showUpload = false;
                }
            },
            handleFileUploads() {
                this.files = [];
                let uploadedFiles = this.$refs.files.files;

                /*
                  Adds the uploaded file to the files array
                */
                for (var i = 0; i < uploadedFiles.length; i++) {
                    this.files.push(uploadedFiles[i]);
                }
            },
            removeFile(key) {
                let fileArray = Array.from(this.files);
                fileArray.splice(key, 1);
                this.files = fileArray;
            },
            cancelBrowsedFiles() {
                $("#files").val(null);
                this.files = [];
            },
            browseEvent() {
                this.$refs.files.click();
            },
            submitFiles() {
                if (this.recordingHospital.hosID == '') {
                    this.$alert("Please select an Account first.", "Missing Account", "info");
                    return;
                }
                if (this.recordingDictator.cliID == '') {
                    this.$alert("Please select a Dictator first.", "Missing Dictator", "info");
                    return;
                }
                let clinicDate = $.trim(this.clinicDate);

                if (clinicDate != '') {
                    if (moment(clinicDate, "DD/MM/YYYY").isValid() == false) {
                        this.$alert("Invalid clinic date. Valid date format is dd/mm/yyyy.", "Invalid Date", "error");
                        return;
                    }
                } else {
                    clinicDate = moment().format("DD/MM/YYYY");
                }
                /*
                  Initialize the form data
                */

                let formData = new FormData();

                /*
                  Iteate over any file sent over appending the files
                  to the form data.
                */
                for (var i = 0; i < this.files.length; i++) {
                    let file = this.files[i];

                    formData.append('files[' + i + ']', file, file.name);
                }

                formData.append("hosID", this.recordingHospital.hosID);
                formData.append("hosShortName", this.recordingHospital.hosShortName);
                formData.append("cliID", this.recordingDictator.cliID);
                formData.append("clinicDate", moment(clinicDate, "DD/MM/YYYY").format("YYYY/MM/DD"));
                formData.append("recorded", false);
                /*
                  Make the request to the POST api/dictation/upload URL
                */
                this.loading = true;
                this.uploading = this.loading;
                this.uploading_progress = 0;
                //let _self = this;
                axios.post('api/dictation/upload', formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                        maxContentLength: Infinity,
                        maxBodyLength: Infinity,
                        onUploadProgress: (progressEvent) => {
                            this.uploading_progress = parseInt(Math.round((100 * progressEvent.loaded) / progressEvent.total));
                        }
                    }
                ).then(() => {
                    $("#files").val(null);
                    this.showUpload = !this.showUpload;
                    this.files = [];
                    this.loading = false;
                    this.uploading = this.loading;
                    this.refreshOnUploaded();
                }).catch(() => {
                    this.loading = false;
                    this.uploading = this.loading;
                    this.$alert('Sorry, something went wrong, Please try again');
                });
            },
            uploadDictation() {
                /*
                  Initialize the form data
                */
                let formData = new FormData();

                /*
                  Iteate over any file sent over appending the files
                  to the form data.
                */

                let voicesInfo = [];
                for (var i = 0; i < this.recorded.length; i++) {
                    if (!this.recorded[i].fileName) {

                        this.recorded[i].fileName = moment().format("MMDDYYYY-HHmmss");
                    }
                    formData.append('files[' + i + ']', this.recorded[i].blob, this.recorded[i].fileName);
                    voicesInfo.push(Object.assign({}, this.recorded[i]));
                }
                formData.append("voicesInfo", JSON.stringify(voicesInfo));
                formData.append("hosID", this.recordingHospital.hosID);
                formData.append("hosShortName", this.recordingHospital.hosShortName);
                formData.append("cliID", this.recordingDictator.cliID);
                formData.append("clinicDate", moment().format("YYYY/MM/DD"));
                formData.append("recorded", true);
                this.loading = true;
                this.uploading = this.loading;
                this.uploading_progress = 0;
                axios.post('api/dictation/upload', formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        maxContentLength: Infinity,
                        maxBodyLength: Infinity,
                        onUploadProgress: (progressEvent) => {
                            this.uploading_progress = parseInt(Math.round((100 * progressEvent.loaded) / progressEvent.total));
                        }
                    }
                ).then(() => {
                    this.recorded = [];
                    this.showUpload = !this.showUpload;
                    this.dictationFiles = [];
                    this.refreshOnUploaded();
                    this.uploading = false;
                }).catch(() => {
                    this.loading = false;
                    this.uploading = this.loading;
                    this.$alert("Something went wrong. Please try again later.");
                });
            },
            refreshOnUploaded() {
                this.forceFetchFromDB = true;
                this.getTranscriptions(this.isSearch).then(data => {
                    let traVM = data;
                    this.totalRecords = traVM.totalRecords;
                    this.transcriptions = traVM.items;
                    this.status = traVM.status;
                    this.xmlFileName = traVM.xmlFileName;
                    sessionStorage.xmlFileName = this.xmlFileName;
                    this.$nextTick(() => {
                        this.selected = [];
                        if (this.transcriptions) {
                            for (var i = 0; i < this.transcriptions.length; i++) {
                                if (this.transcriptions[i].traId > 0) {
                                    this.$refs.table[i].click();
                                    break;
                                }
                            }
                        }
                    });
                }).catch((err) => {
                    this.loading = false;
                    this.onError(err);
                }).finally(() => {
                    this.loading = false;
                });
            },
            traHosChange(hospital) {
                this.loading = true;
                axios.get(`api/transcription/loaddictators?cliID=${this.clientID}&hosID=${hospital.hosID}`)
                    .then((response) => {
                        this.traDictators = response.data.items;
                        for (let i = 0; i < this.traDictators.length; i++) {
                            let item = this.traDictators[i];
                            if (item.cliID == this.transcription.cliID) {
                                this.traCli = { cliID: item.cliID, cliName: item.cliName };
                                break;
                            }
                        }
                        if (typeof this.traCli.cliID === 'undefined') {
                            this.disabledChangeAccount = true;
                            this.traCli = { cliID: this.transcription.cliID, cliName: this.transcription.cliName };
                        }
                        this.$nextTick(() => { this.loading = false; });
                    })
                    .catch(() => {
                        this.loading = false;
                    }).finally(() => { this.loading = false; });
            },
            recordingHospitalChange(hospital) {
                this.loading = true;
                axios.get(`api/transcription/loaddictators?cliID=${this.clientID}&hosID=${hospital.hosID}`)
                    .then((response) => {
                        this.dictatorsWithoutAllOption = response.data.items;
                        // by default login dictator is selected
                        let defaultDictator = this.$_.find(this.dictatorsWithoutAllOption, (dic) => { return dic.cliID == this.clientID });
                        if (defaultDictator) {
                            this.recordingDictator = defaultDictator;
                        }
                        else {
                            for (let i = 0; i < this.dictatorsWithoutAllOption.length; i++) {
                                if (this.dictatorsWithoutAllOption[i].cliID != '') {
                                    this.recordingDictator = this.dictatorsWithoutAllOption[i];
                                    break;
                                }
                            }
                        }
                        this.$nextTick(() => { this.loading = false; });
                    })
                    .catch(() => { this.loading = false; })
                    .finally(() => { this.loading = false; });
            },
            getDictation() {
                if (this.dictationSrc) {
                    this.showPlayDictation = true;
                    this.$refs.player.play();
                } else if (this.transcription && this.transcription.cliID) {
                    this.loading = true;
                    this.axios({
                        url: `api/dictation/download?cliID=${this.transcription.cliID}&dicActualName=${this.transcription.dicActualName}`,
                        method: 'GET',
                        responseType: 'blob'
                    }).then((response) => {
                        this.loading = false;
                        let type = "audio/mpeg";
                        if (this.transcription.dicActualName.toLowerCase().trim().endsWith('.wav')) {
                            type = "audio/wav";
                        } else if (this.transcription.dicActualName.toLowerCase().trim().endsWith('.acc')) {
                            type = "audio/aac";
                        } else if (this.transcription.dicActualName.toLowerCase().trim().endsWith('.m4a')) {
                            type = "audio/mp4";
                        }
                        this.audioType = type;
                        this.dictationSrc = window.URL.createObjectURL(new Blob([response.data], { type: type }));
                        this.showPlayDictation = true;
                    }).catch((error) => {
                        if (error.response.status == 404) {
                            this.loading = false;
                            this.$alert(error, "Play Dictation", "error");
                        }
                        else {
                            this.axios({
                                url: `api/dictation/download?cliID=${this.transcription.cliID}&dicActualName=${this.transcription.dicActualName}&downloadOriginal=true`,
                                method: 'GET',
                                responseType: 'blob'
                            }).then((res) => {
                                let fileLink = document.createElement('a');
                                fileLink.href = window.URL.createObjectURL(new Blob([res.data], { type: 'application/octet-stream' }));
                                fileLink.setAttribute('download', this.transcription.dicActualName);
                                document.body.appendChild(fileLink);
                                fileLink.click();
                                this.loading = false;
                            }).catch((err) => {
                                this.loading = false;
                                this.$alert(err, "Play Dictation", "error");
                            });
                        }
                    });
                }
            },
            downloadDictation() {
                let fileLink = document.createElement('a');
                fileLink.href = this.dictationSrc;
                fileLink.setAttribute('download', this.transcription.dicActualName);
                document.body.appendChild(fileLink);
                fileLink.click();
            },
            hidePlayDictation() {
                let player = this.$refs.player;
                player.pause();
                player.currentTime = 0;
                this.showPlayDictation = false;
            },
            allLettersEvent() {
                let url = `/patienthistory?pID=${this.transcription.traPatientNo}&pname=${this.transcription.traSubject}&pdob=${this.transcription.traDOBString}`;
                window.open(url, '_blank');
            },
            allLettersNHSEvent() {
                let url = `/patienthistory?pID=${this.transcription.traNHSNo}&pname=${this.transcription.traSubject}&pdob=${this.transcription.traDOBString}&isNHS=true`;
                window.open(url, '_blank');
            },
            pageChange(page) {
                if (this.isDirty()) {
                    this.confirmSaveChanges().then((res) => {
                        if (res.value) {
                            this.loading = true;
                            this.saveOnBeforeLeaving().then(() => {
                                this.resetDirty();
                                this.pageChange(page);
                            }).finally(() => {
                                this.loading = false;
                            });
                        }
                        else {
                            this.resetDirty();
                            this.pageChange(page);
                        }
                    });
                    return;
                }
                this.options.page = page;
                this.fetchData();
            },
            selectDictation(index) {
                $(".dictation").removeClass("dictation-active");
                $(".dictation").eq(index).addClass("dictation-active");
            },
            removeRecordedDictation(index, dictation) {
                this.$confirm(`Are you sure you want to delete this "${dictation.fileName}" dictation?`, "Confirm", "warning").then(() => {
                    this.recorded.splice(index, 1);
                    if (this.$refs.recorder) {
                        this.$refs.recorder.removeRecord(index);
                    }
                    $(".dictation").removeClass("dictation-active");
                }).catch(() => { });
            },
            downloadRecordedDictation(recordedDictation) {
                let fileLink = document.createElement('a');
                fileLink.href = recordedDictation.src;
                fileLink.setAttribute('download', recordedDictation.fileName);
                document.body.appendChild(fileLink);
                fileLink.click();
            },
            playRecordedDictation(recordedDictation) {
                let url = (window.URL || window.webkitURL).createObjectURL(recordedDictation.blob);
                let fileLink = document.createElement('a');
                fileLink.href = url;
                fileLink.setAttribute("target", "_blank");
                document.body.appendChild(fileLink);
                fileLink.click();
            },
            onInitEditor() {
                this.$nextTick(() => {
                    //var freeTiny = document.querySelector('.tox.tox-tinymce-aux');
                    //if (freeTiny) {
                    //    freeTiny.style.display = 'none';
                    //}
                    if (this.isMobile) {
                        this.$refs.editor.init.content_css = null;
                    }
                    setEditorContentHeight();
                    // get hospitals list
                    if (this.clientID != null) {
                        this.loadHosptials().then(data => {
                            let deepCopy = true;
                            this.accountsWithoutAllOption = $.extend(deepCopy, [], data.items);
                            let accounts = data.items;
                            if (accounts.length > 1) {
                                accounts.splice(0, 0, { hosID: "", hosName: "All Accounts" });
                            }
                            this.accounts = accounts;
                            this.selectedHospital = this.accounts[0];
                            this.sFilterHospital = this.accounts[0];
                        });
                    }
                    else {
                        this.showLogin = true;
                        this.loading = false;
                    }
                });
            },
            onError(err) {
                if (typeof err === "undefined") {
                    this.$alert("Sorry, something went wrong. Please try again, or refresh the page", "Unable to process", "error");
                } else {
                    var msg;
                    if (typeof err.response !== "undefined") {
                        msg = err.response.data;
                    } else if (typeof err.request !== "undefined") {
                        msg = err.request.data;
                    } else {
                        msg = err.message;
                    }
                    this.$alert(msg, "Unable to process", "error");
                }
            },
        }, // ends methods
        async created() {
            if (!navigator.mediaDevices) {
                this.isRecordingSupported = false;
            } else {
                this.isRecordingSupported = true;
            }
            $("input[type=text], textarea").on({
                'touchstart': function () {
                    zoomDisable();
                }
            });
            $("input[type=text], textarea").on({
                'touchend': function () {
                    setTimeout(zoomEnable, 500);
                }
            });

            axios.interceptors.request.use((config) => {
                this.loading = true;
                // trigger 'loading=true' event here
                return config;
            }, (error) => {
                // trigger 'loading=false' event here
                this.loading = false;
                return Promise.reject(error);
            });

            axios.interceptors.response.use((response) => {
                // trigger 'loading=false' event here
                this.loading = false;
                return response;
            }, (error) => {
                this.loading = false;
                // trigger 'loading=false' event here
                return Promise.reject(error);
            });
        },
    }
    // javascript code
    function zoomDisable() {
        $('head meta[name=viewport]').remove();
        $('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0" />');
    }
    function zoomEnable() {
        $('head meta[name=viewport]').remove();
        $('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=1" />');
    }
    function setStorageValue(key, data) {
        sessionStorage.setItem(key, data);
    }
    function getStorageValue(key) {
        return sessionStorage.getItem(key);
    }

    function setEditorContentHeight() {
        $('.ck.ck-toolbar').css('font-size', '8pt');
        $("style[name='ck-content']").remove();
        var inputDocumentH = 0;

        $('.r-height').each(function () {
            inputDocumentH += $(this).outerHeight(true);
        });
        var height = $(window).outerHeight() - inputDocumentH - $('#toolbar-container').outerHeight(true);
        if (height < 260) {
            height = 260; // set min-height
        } else {
            height -= 5;
        }
        $('.tox.tox-tinymce').css('height', height);

        if (window.innerWidth <= 1366) {
            $('.v-content__wrap .container--fluid').css({ 'max-width': '98.5%' });
        } else {
            $('.v-content__wrap .container--fluid').css({ 'max-width': '100%' });
        }
    }

    window.onresize = function () {
        setEditorContentHeight();
    };
</script>
<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
    body {
    }

    .swal2-icon {
        font-size: 12px;
    }

    .v-content__wrap .container--fluid {
        max-width: 1366px;
    }

    .progress-circular {
        margin: 1rem;
        font-weight: 600;
    }

    #paginationDiv ul {
        padding: 1% !important;
    }

    .ar {
        width: auto !important;
        box-shadow: unset !important;
        border-radius: 0px !important;
    }

    .grid-option button {
        margin-right: 5px;
    }

        .grid-option button:last-child {
            margin-right: 0px;
        }

    .v-data-table__wrapper {
        overflow-x: hidden !important;
    }

    table thead th {
        background-color: #016BAB !important;
        color: #fff !important;
    }

        table thead th i {
            color: #fff !important;
        }


    .v-data-table td, .v-data-table th {
        padding: 0 0 0 5px !important;
    }

        .v-data-table td:first-child, .v-data-table th:first-child {
            padding: 0px !important;
        }

    .editor-page {
        width: 99.1%;
        display: table;
    }

    .editor-page-content, .grid {
        display: table-cell;
    }

    .editor-page-content {
        /*min-width: 948px;*/
    }

    .grid {
        padding-right: 10px;
        width: 400px;
    }

        .grid table {
            background-color: #E4EDF8;
            font-size: 8pt !important;
        }

            .grid table tbody tr td {
                font-size: 8pt;
                border-right: 1px solid #D9E9F8;
                cursor: pointer;
            }

            .grid table tbody tr {
                background-color: #FCFCFC;
            }

    .lds-ripple {
        display: inline-block;
        position: relative;
        width: 64px;
        height: 64px;
    }

        .lds-ripple div {
            position: absolute;
            border: 4px solid #fff;
            opacity: 1;
            border-radius: 50%;
            animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
        }

            .lds-ripple div:nth-child(2) {
                animation-delay: -0.5s;
            }

    .selectedRowColor {
        background-color: #D9E9F8 !important;
        color: #fff;
        font-weight: 600;
    }

        .selectedRowColor td:first-child {
            border-left: 3px solid #016BAB !important;
        }

    #editor p {
        margin: 0px;
        padding: 0px;
    }

    #editor *:first-child {
        margin-top: 20px;
    }

    #editor *:last-child {
        margin-bottom: 20px;
    }

    p {
        display: block;
        margin-block-start: -1em !important;
        margin-block-end: -1em !important;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
    }

    .mce-content-body h2 {
        mso-style-unhide: no;
        mso-style-qformat: yes;
        mso-style-link: "Heading 2 Char";
        mso-style-next: Normal;
        margin: 0in;
        margin-bottom: .0001pt;
        line-height: 115%;
        mso-pagination: widow-orphan;
        page-break-after: avoid;
        mso-outline-level: 2;
        tab-stops: right 6.25in;
        font-size: 10.0pt;
        mso-bidi-font-size: 11.0pt;
        mso-ansi-language: EN-GB;
        font-weight: bold;
        mso-bidi-font-weight: normal;
    }


    .mce-content-body p {
        mso-style-unhide: no;
        mso-margin-top-alt: auto;
        margin-right: 0in;
        mso-margin-bottom-alt: auto;
        margin-left: 0in;
        mso-pagination: widow-orphan;
        font-size: 12.0pt;
        line-height: 1.15;
    }



    .cls-dictations .dictation:first-child {
        margin-top: 20px;
    }

    .dictation > div[class^="col-"] {
        padding: 5px 0 5px 0;
    }

    .dictation > .input-group {
        padding: 5px 0 5px 10px;
    }

    .recorded-grid-heading div[class^="col-"] {
        padding: 0 0 0 0;
    }

    .dictation-active {
        background-color: #D9E9F8;
    }

    .fa-trash-alt:hover {
        color: #dc3545;
    }

    .v-card__text.container {
        max-width: 85vw;
    }

    .v-application ul, .v-application ol {
        padding-left: 0px !important;
    }

    @keyframes lds-ripple {
        0% {
            top: 28px;
            left: 28px;
            width: 0;
            height: 0;
            opacity: 1;
        }

        100% {
            top: -1px;
            left: -1px;
            width: 58px;
            height: 58px;
            opacity: 0;
        }
    }

    input[type="file"] {
        position: absolute;
        top: -500px;
    }

    div.file-listing {
        width: 540px;
    }

    span.remove-file {
        color: red;
        cursor: pointer;
        float: right;
    }

    .tabs-component {
        margin: 10px 0;
    }

    .tabs-component-tabs {
        border: solid 1px #ddd;
        border-radius: 6px;
        margin-bottom: 5px;
        text-decoration: none;
    }

    .dictation-grid > .dictation:nth-child(odd) {
        background-color: rgb(247, 249, 251);
    }

    .dictation-grid > .dictation:nth-child(even) {
        background-color: #E4EDF8;
    }

    .lighten-2 {
        background-color: #016BAB;
        color: #fff;
    }


    @media (min-width: 700px) {
        .tabs-component-tabs {
            border: 0;
            align-items: stretch;
            display: flex;
            justify-content: flex-start;
            margin-bottom: -1px;
        }
    }

    .tabs-component-tab {
        color: #999;
        font-size: 14px;
        font-weight: 600;
        margin-right: 0;
        list-style: none;
    }

        .tabs-component-tab:not(:last-child) {
            border-bottom: dotted 1px #ddd;
        }

        .tabs-component-tab:hover {
            color: #666;
        }

        .tabs-component-tab.is-active {
            color: #000;
        }

        .tabs-component-tab.is-disabled * {
            color: #cdcdcd;
            cursor: not-allowed !important;
        }

    @media (min-width: 700px) {
        .tabs-component-tab {
            background-color: #fff;
            border: solid 1px #ddd;
            border-radius: 3px 3px 0 0;
            margin-right: .5em;
            transform: translateY(2px);
            transition: transform .3s ease;
        }

            .tabs-component-tab.is-active {
                border-bottom: solid 1px #fff;
                z-index: 2;
                transform: translateY(0);
            }
    }

    .tabs-component-tab-a {
        align-items: center;
        color: inherit;
        display: flex;
        padding: .75em 1em;
        text-decoration: none;
    }

    .tabs-component-panels {
        padding: 4em 0;
        padding-top: 0px;
    }

    .ar-recorder__duration {
        margin-top: 31px;
    }

    .ar-records {
        display: none;
        margin-top: 5px;
        width: 100% !important;
    }

    .ar-records__record {
        width: 90% !important;
    }

    .ar-player {
        display: none !important;
    }

    .tabs-component-panels {
        padding-bottom: 0px !important;
    }

    .grid-option .p-2 {
        padding: .1rem !important;
    }

    .ar-icon--rec {
        pointer-events: none;
        cursor: not-allowed;
    }

    .multiselect__tag {
        display: none !important;
    }

    .btn-outline-none {
        outline: none !important;
        border: none !important;
    }

    @media (min-width: 700px) {
        .tabs-component-panels {
            border-top-left-radius: 0;
            background-color: #fff;
            border: solid 1px #ddd;
            border-radius: 0 6px 6px 6px;
            box-shadow: 0 0 10px rgba(0, 0, 0, .05);
            padding: 4em 2em;
            padding-top: 0px;
        }
    }

    form.search .row .col-sm-12 {
        padding-top: 0px;
        padding-bottom: 0px;
    }

    .form-group .v-input {
        padding: 0;
        margin: 0;
    }

    .traStatus button, .traStatus button:focus {
        outline: none;
        box-shadow: none;
    }
    button.active {
        font-weight: 600;
        color: #016BAB;
    }
</style>
